(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ehm"] = factory();
	else
		root["ehm"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 58);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.0' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(19)('wks');
var uid = __webpack_require__(15);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(42);
var toPrimitive = __webpack_require__(26);
var dP = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(0);
var ctx = __webpack_require__(25);
var hide = __webpack_require__(11);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(13)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(75);
var defined = __webpack_require__(21);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(1);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(2);
var createDesc = __webpack_require__(14);
module.exports = __webpack_require__(8) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(46);
var enumBugKeys = __webpack_require__(32);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(81)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(44)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(96);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(34);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(21);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(4);
var toObject = __webpack_require__(20);
var IE_PROTO = __webpack_require__(23)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(19)('keys');
var uid = __webpack_require__(15);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(5);
var core = __webpack_require__(0);
var fails = __webpack_require__(13);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(66);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(7);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(72);
var global = __webpack_require__(3);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(12);
var TO_STRING_TAG = __webpack_require__(1)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(6);
var dPs = __webpack_require__(77);
var enumBugKeys = __webpack_require__(32);
var IE_PROTO = __webpack_require__(23)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(43)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(80).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(2).f;
var has = __webpack_require__(4);
var TAG = __webpack_require__(1)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(98), __esModule: true };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(0);
var LIBRARY = __webpack_require__(29);
var wksExt = __webpack_require__(10);
var defineProperty = __webpack_require__(2).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(56);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var _defineProperty = __webpack_require__(56);var _defineProperty2 = _interopRequireDefault(_defineProperty);var _getOwnPropertySymbols = __webpack_require__(110);var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);var _getOwnPropertyNames = __webpack_require__(112);var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);var _typeof2 = __webpack_require__(18);var _typeof3 = _interopRequireDefault(_typeof2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /*;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             	@module-license:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		The MIT License (MIT)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		@mit-license
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		Copyright (@c) 2017 Richeve Siodina Bebedor
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		@email: richeve.bebedor@gmail.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		Permission is hereby granted, free of charge, to any person obtaining a copy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		of this software and associated documentation files (the "Software"), to deal
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		in the Software without restriction, including without limitation the rights
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		copies of the Software, and to permit persons to whom the Software is
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		furnished to do so, subject to the following conditions:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		The above copyright notice and this permission notice shall be included in all
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		copies or substantial portions of the Software.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		SOFTWARE.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             	@end-module-license
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             	@module-configuration:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		{
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"package": "harden",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"path": "harden/harden.js",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"file": "harden.js",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"module": "harden",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"author": "Richeve S. Bebedor",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"eMail": "richeve.bebedor@gmail.com",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"contributors": [
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             				"John Lenon Maghanoy <johnlenonmaghanoy@gmail.com>",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             				"Vinse Vinalon <vinsevinalon@gmail.com>"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			],
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"repository": "https://github.com/volkovasystems/harden.git",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"test": "harden-test.js",
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"global": true
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             	@end-module-configuration
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             	@module-documentation:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		Makes your property-value non-enumerable, non-configurable and non-writable.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		This will check if the property exists, and it will harden the value if the property exists.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             	@end-module-documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             */

var harden = function harden(property, value, entity) {
	/*;
                                                       	@meta-configuration:
                                                       		{
                                                       			"property:required": [
                                                       				"string",
                                                       				"symbol",
                                                       				"number"
                                                       			],
                                                       			"value:required": "*",
                                                       			"entity:optional": "object"
                                                       		}
                                                       	@end-meta-configuration
                                                       */

	if (property === "" ||

	typeof property != "string" && (typeof property === "undefined" ? "undefined" : (0, _typeof3.default)(property)) != "symbol" && typeof property != "number" ||

	typeof property == "number" && isNaN(property))
	{
		throw new Error("invalid property");
	}

	if (typeof entity == "undefined" && arguments.length == 2) {
		if (typeof this != "undefined") {
			entity = this;

		} else if (typeof global != "undefined") {
			entity = global;

		} else if (typeof window != "undefined") {
			entity = window;

		} else {
			throw new Error("cannot resolve entity as context");
		}
	}

	/*;
   	@note:
   		Checking if key exists is intensive because we can define an undefined property
   			and the key will still exists.
   	@end-note
   */
	if (typeof entity[property] != "undefined" ||

	(0, _getOwnPropertyNames2.default)(entity).some(function (key) {return key === property;}) ||

	(typeof property === "undefined" ? "undefined" : (0, _typeof3.default)(property)) == "symbol" &&
	(0, _getOwnPropertySymbols2.default)(entity).
	some(function (symbol) {return symbol === property;}))
	{
		return entity;
	}

	try {
		(0, _defineProperty2.default)(entity, property, {
			"value": value,

			"configurable": false,
			"enumerable": false,
			"writable": false });


	} catch (error) {
		throw new Error("cannot harden property, " + property + ", " + error.stack);
	}

	return entity;
};

module.exports = harden;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109)))

/***/ }),
/* 40 */
/***/ (function(module, exports) {



/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(64), __esModule: true };

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(13)(function () {
  return Object.defineProperty(__webpack_require__(43)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(29);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(45);
var hide = __webpack_require__(11);
var has = __webpack_require__(4);
var Iterators = __webpack_require__(12);
var $iterCreate = __webpack_require__(76);
var setToStringTag = __webpack_require__(33);
var getPrototypeOf = __webpack_require__(22);
var ITERATOR = __webpack_require__(1)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(4);
var toIObject = __webpack_require__(9);
var arrayIndexOf = __webpack_require__(78)(false);
var IE_PROTO = __webpack_require__(23)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(31);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(28);
var TAG = __webpack_require__(1)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(48);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(12);
module.exports = __webpack_require__(0).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(15)('meta');
var isObject = __webpack_require__(7);
var has = __webpack_require__(4);
var setDesc = __webpack_require__(2).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(13)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(4);
var DESCRIPTORS = __webpack_require__(8);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(45);
var META = __webpack_require__(50).KEY;
var $fails = __webpack_require__(13);
var shared = __webpack_require__(19);
var setToStringTag = __webpack_require__(33);
var uid = __webpack_require__(15);
var wks = __webpack_require__(1);
var wksExt = __webpack_require__(10);
var wksDefine = __webpack_require__(35);
var keyOf = __webpack_require__(99);
var enumKeys = __webpack_require__(100);
var isArray = __webpack_require__(101);
var anObject = __webpack_require__(6);
var toIObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(26);
var createDesc = __webpack_require__(14);
var _create = __webpack_require__(30);
var gOPNExt = __webpack_require__(53);
var $GOPD = __webpack_require__(55);
var $DP = __webpack_require__(2);
var $keys = __webpack_require__(16);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(54).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(36).f = $propertyIsEnumerable;
  __webpack_require__(52).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(29)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key) {
    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(9);
var gOPN = __webpack_require__(54).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(46);
var hiddenKeys = __webpack_require__(32).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(36);
var createDesc = __webpack_require__(14);
var toIObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(26);
var has = __webpack_require__(4);
var IE8_DOM_DEFINE = __webpack_require__(42);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(107), __esModule: true };

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*;
              	@module-license:
              		The MIT License (MIT)
              		@mit-license
              
              		Copyright (@c) 2017 Richeve Siodina Bebedor
              		@email: richeve.bebedor@gmail.com
              
              		Permission is hereby granted, free of charge, to any person obtaining a copy
              		of this software and associated documentation files (the "Software"), to deal
              		in the Software without restriction, including without limitation the rights
              		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              		copies of the Software, and to permit persons to whom the Software is
              		furnished to do so, subject to the following conditions:
              
              		The above copyright notice and this permission notice shall be included in all
              		copies or substantial portions of the Software.
              
              		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              		SOFTWARE.
              	@end-module-license
              
              	@module-configuration:
              		{
              			"package": "falzy",
              			"path": "falzy/falzy.js",
              			"file": "falzy.js",
              			"module": "falzy",
              			"author": "Richeve S. Bebedor",
              			"eMail": "richeve.bebedor@gmail.com",
              			"contributors": [
              				"John Lenon Maghanoy <johnlenonmaghanoy@gmail.com>",
              				"Vinse Vinalon <vinsevinalon@gmail.com>"
              			],
              			"repository": "https://github.com/volkovasystems/falzy.git",
              			"test": "falzy-test.js",
              			"global": true
              		}
              	@end-module-configuration
              
              	@module-documentation:
              		Check if the value is undefined, null, empty string, and NaN.
              	@end-module-documentation
              
              	@note:
              		This module should not have a dependency and should remain as simple as possible.
              	@end-note
              */

var falzy = function falzy(value) {
	/*;
                                   	@meta-configuration:
                                   		{
                                   			"value:required": "*"
                                   		}
                                   	@end-meta-configuration
                                   */

	if (typeof value == "number") {
		return isNaN(value);
	}

	return typeof value == "undefined" || value === null || value === "";
};

module.exports = falzy;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZhbHp5LnN1cHBvcnQuanMiXSwibmFtZXMiOlsiZmFsenkiLCJ2YWx1ZSIsImlzTmFOIiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6IkFBQUE7O0FBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQXNEQSxJQUFNQSxRQUFRLFNBQVNBLEtBQVQsQ0FBZ0JDLEtBQWhCLEVBQXVCO0FBQ3BDOzs7Ozs7OztBQVFBLEtBQUksT0FBT0EsS0FBUCxJQUFnQixRQUFwQixFQUE4QjtBQUM3QixTQUFPQyxNQUFPRCxLQUFQLENBQVA7QUFDQTs7QUFFRCxRQUFTLE9BQU9BLEtBQVAsSUFBZ0IsV0FBaEIsSUFBK0JBLFVBQVUsSUFBekMsSUFBaURBLFVBQVUsRUFBcEU7QUFDQSxDQWREOztBQWdCQUUsT0FBT0MsT0FBUCxHQUFpQkosS0FBakIiLCJmaWxlIjoiZmFsenkuc3VwcG9ydC5qcyIsInNvdXJjZXNDb250ZW50IjpbIlwidXNlIHN0cmljdFwiO1xuXG4vKjtcblx0QG1vZHVsZS1saWNlbnNlOlxuXHRcdFRoZSBNSVQgTGljZW5zZSAoTUlUKVxuXHRcdEBtaXQtbGljZW5zZVxuXG5cdFx0Q29weXJpZ2h0IChAYykgMjAxNyBSaWNoZXZlIFNpb2RpbmEgQmViZWRvclxuXHRcdEBlbWFpbDogcmljaGV2ZS5iZWJlZG9yQGdtYWlsLmNvbVxuXG5cdFx0UGVybWlzc2lvbiBpcyBoZXJlYnkgZ3JhbnRlZCwgZnJlZSBvZiBjaGFyZ2UsIHRvIGFueSBwZXJzb24gb2J0YWluaW5nIGEgY29weVxuXHRcdG9mIHRoaXMgc29mdHdhcmUgYW5kIGFzc29jaWF0ZWQgZG9jdW1lbnRhdGlvbiBmaWxlcyAodGhlIFwiU29mdHdhcmVcIiksIHRvIGRlYWxcblx0XHRpbiB0aGUgU29mdHdhcmUgd2l0aG91dCByZXN0cmljdGlvbiwgaW5jbHVkaW5nIHdpdGhvdXQgbGltaXRhdGlvbiB0aGUgcmlnaHRzXG5cdFx0dG8gdXNlLCBjb3B5LCBtb2RpZnksIG1lcmdlLCBwdWJsaXNoLCBkaXN0cmlidXRlLCBzdWJsaWNlbnNlLCBhbmQvb3Igc2VsbFxuXHRcdGNvcGllcyBvZiB0aGUgU29mdHdhcmUsIGFuZCB0byBwZXJtaXQgcGVyc29ucyB0byB3aG9tIHRoZSBTb2Z0d2FyZSBpc1xuXHRcdGZ1cm5pc2hlZCB0byBkbyBzbywgc3ViamVjdCB0byB0aGUgZm9sbG93aW5nIGNvbmRpdGlvbnM6XG5cblx0XHRUaGUgYWJvdmUgY29weXJpZ2h0IG5vdGljZSBhbmQgdGhpcyBwZXJtaXNzaW9uIG5vdGljZSBzaGFsbCBiZSBpbmNsdWRlZCBpbiBhbGxcblx0XHRjb3BpZXMgb3Igc3Vic3RhbnRpYWwgcG9ydGlvbnMgb2YgdGhlIFNvZnR3YXJlLlxuXG5cdFx0VEhFIFNPRlRXQVJFIElTIFBST1ZJREVEIFwiQVMgSVNcIiwgV0lUSE9VVCBXQVJSQU5UWSBPRiBBTlkgS0lORCwgRVhQUkVTUyBPUlxuXHRcdElNUExJRUQsIElOQ0xVRElORyBCVVQgTk9UIExJTUlURUQgVE8gVEhFIFdBUlJBTlRJRVMgT0YgTUVSQ0hBTlRBQklMSVRZLFxuXHRcdEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFIEFORCBOT05JTkZSSU5HRU1FTlQuIElOIE5PIEVWRU5UIFNIQUxMIFRIRVxuXHRcdEFVVEhPUlMgT1IgQ09QWVJJR0hUIEhPTERFUlMgQkUgTElBQkxFIEZPUiBBTlkgQ0xBSU0sIERBTUFHRVMgT1IgT1RIRVJcblx0XHRMSUFCSUxJVFksIFdIRVRIRVIgSU4gQU4gQUNUSU9OIE9GIENPTlRSQUNULCBUT1JUIE9SIE9USEVSV0lTRSwgQVJJU0lORyBGUk9NLFxuXHRcdE9VVCBPRiBPUiBJTiBDT05ORUNUSU9OIFdJVEggVEhFIFNPRlRXQVJFIE9SIFRIRSBVU0UgT1IgT1RIRVIgREVBTElOR1MgSU4gVEhFXG5cdFx0U09GVFdBUkUuXG5cdEBlbmQtbW9kdWxlLWxpY2Vuc2VcblxuXHRAbW9kdWxlLWNvbmZpZ3VyYXRpb246XG5cdFx0e1xuXHRcdFx0XCJwYWNrYWdlXCI6IFwiZmFsenlcIixcblx0XHRcdFwicGF0aFwiOiBcImZhbHp5L2ZhbHp5LmpzXCIsXG5cdFx0XHRcImZpbGVcIjogXCJmYWx6eS5qc1wiLFxuXHRcdFx0XCJtb2R1bGVcIjogXCJmYWx6eVwiLFxuXHRcdFx0XCJhdXRob3JcIjogXCJSaWNoZXZlIFMuIEJlYmVkb3JcIixcblx0XHRcdFwiZU1haWxcIjogXCJyaWNoZXZlLmJlYmVkb3JAZ21haWwuY29tXCIsXG5cdFx0XHRcImNvbnRyaWJ1dG9yc1wiOiBbXG5cdFx0XHRcdFwiSm9obiBMZW5vbiBNYWdoYW5veSA8am9obmxlbm9ubWFnaGFub3lAZ21haWwuY29tPlwiLFxuXHRcdFx0XHRcIlZpbnNlIFZpbmFsb24gPHZpbnNldmluYWxvbkBnbWFpbC5jb20+XCJcblx0XHRcdF0sXG5cdFx0XHRcInJlcG9zaXRvcnlcIjogXCJodHRwczovL2dpdGh1Yi5jb20vdm9sa292YXN5c3RlbXMvZmFsenkuZ2l0XCIsXG5cdFx0XHRcInRlc3RcIjogXCJmYWx6eS10ZXN0LmpzXCIsXG5cdFx0XHRcImdsb2JhbFwiOiB0cnVlXG5cdFx0fVxuXHRAZW5kLW1vZHVsZS1jb25maWd1cmF0aW9uXG5cblx0QG1vZHVsZS1kb2N1bWVudGF0aW9uOlxuXHRcdENoZWNrIGlmIHRoZSB2YWx1ZSBpcyB1bmRlZmluZWQsIG51bGwsIGVtcHR5IHN0cmluZywgYW5kIE5hTi5cblx0QGVuZC1tb2R1bGUtZG9jdW1lbnRhdGlvblxuXG5cdEBub3RlOlxuXHRcdFRoaXMgbW9kdWxlIHNob3VsZCBub3QgaGF2ZSBhIGRlcGVuZGVuY3kgYW5kIHNob3VsZCByZW1haW4gYXMgc2ltcGxlIGFzIHBvc3NpYmxlLlxuXHRAZW5kLW5vdGVcbiovXG5cbmNvbnN0IGZhbHp5ID0gZnVuY3Rpb24gZmFsenkoIHZhbHVlICl7XG5cdC8qO1xuXHRcdEBtZXRhLWNvbmZpZ3VyYXRpb246XG5cdFx0XHR7XG5cdFx0XHRcdFwidmFsdWU6cmVxdWlyZWRcIjogXCIqXCJcblx0XHRcdH1cblx0XHRAZW5kLW1ldGEtY29uZmlndXJhdGlvblxuXHQqL1xuXG5cdGlmKCB0eXBlb2YgdmFsdWUgPT0gXCJudW1iZXJcIiApe1xuXHRcdHJldHVybiBpc05hTiggdmFsdWUgKTtcblx0fVxuXG5cdHJldHVybiAoIHR5cGVvZiB2YWx1ZSA9PSBcInVuZGVmaW5lZFwiIHx8IHZhbHVlID09PSBudWxsIHx8IHZhbHVlID09PSBcIlwiICk7XG59O1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZhbHp5O1xuIl19


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*;
              	@module-license:
              		The MIT License (MIT)
              		@mit-license
              
              		Copyright (@c) 2017 Richeve Siodina Bebedor
              		@email: richeve.bebedor@gmail.com
              
              		Permission is hereby granted, free of charge, to any person obtaining a copy
              		of this software and associated documentation files (the "Software"), to deal
              		in the Software without restriction, including without limitation the rights
              		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              		copies of the Software, and to permit persons to whom the Software is
              		furnished to do so, subject to the following conditions:
              
              		The above copyright notice and this permission notice shall be included in all
              		copies or substantial portions of the Software.
              
              		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              		SOFTWARE.
              	@end-module-license
              
              	@module-configuration:
              		{
              			"package": "ehm",
              			"path": "ehm/ehm.js",
              			"file": "ehm.js",
              			"module": "ehm",
              			"author": "Richeve S. Bebedor",
              			"eMail": "richeve.bebedor@gmail.com",
              			"repository": "https://github.com/volkovasystems/ehm.git",
              			"test": "ehm-test.js",
              			"global": true
              		}
              	@end-module-configuration
              
              	@module-documentation:
              		Meta object class construct.
              	@end-module-documentation
              */



//: @client:
var Meta = __webpack_require__(59);
//: @end-client

var ehm = function ehm() {
	return Meta;
};

module.exports = ehm;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*;
              	@submodule-license:
              		The MIT License (MIT)
              		@mit-license
              
              		Copyright (@c) 2017 Richeve Siodina Bebedor
              		@email: richeve.bebedor@gmail.com
              
              		Permission is hereby granted, free of charge, to any person obtaining a copy
              		of this software and associated documentation files (the "Software"), to deal
              		in the Software without restriction, including without limitation the rights
              		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              		copies of the Software, and to permit persons to whom the Software is
              		furnished to do so, subject to the following conditions:
              
              		The above copyright notice and this permission notice shall be included in all
              		copies or substantial portions of the Software.
              
              		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              		SOFTWARE.
              	@end-submodule-license
              
              	@submodule-configuration:
              		{
              			"package": "ehm",
              			"path": "ehm/meta.module.js",
              			"file": "meta.module.js",
              			"module": "ehm",
              			"author": "Richeve S. Bebedor",
              			"eMail": "richeve.bebedor@gmail.com",
              			"repository": "https://github.com/volkovasystems/ehm.git",
              			"test": "ehm-test.js",
              			"global": false,
              			"internal": true,
              			"class": true
              		}
              	@end-submodule-configuration
              
              	@submodule-documentation:
              		Meta class construct.
              	@end-submodule-documentation
              
              	@include:
              		{
              			"harden": "harden",
              			"sxty4": "sxty4"
              		}
              	@end-include
              */var _toStringTag = __webpack_require__(60);var _toStringTag2 = _interopRequireDefault(_toStringTag);var _stringify = __webpack_require__(62);var _stringify2 = _interopRequireDefault(_stringify);var _getPrototypeOf = __webpack_require__(41);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _toPrimitive = __webpack_require__(67);var _toPrimitive2 = _interopRequireDefault(_toPrimitive);var _slicedToArray2 = __webpack_require__(69);var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);var _freeze = __webpack_require__(86);var _freeze2 = _interopRequireDefault(_freeze);var _from = __webpack_require__(89);var _from2 = _interopRequireDefault(_from);var _typeof2 = __webpack_require__(18);var _typeof3 = _interopRequireDefault(_typeof2);var _hasInstance = __webpack_require__(104);var _hasInstance2 = _interopRequireDefault(_hasInstance);var _classCallCheck2 = __webpack_require__(37);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(38);var _createClass3 = _interopRequireDefault(_createClass2);var _symbol = __webpack_require__(34);var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var harden = __webpack_require__(39);
var sxty4 = __webpack_require__(115);

var NAME = (0, _symbol2.default)("name");
var ENTITY = (0, _symbol2.default)("entity");
var TYPE = (0, _symbol2.default)("type");

var ERROR = (0, _symbol2.default)("error");

var OBJECT = (0, _symbol2.default)("object");
var BOOLEAN = (0, _symbol2.default)("boolean");
var STRING = (0, _symbol2.default)("string");
var NUMBER = (0, _symbol2.default)("number");
var VALUE = (0, _symbol2.default)("value");

var GARBAGE = (0, _symbol2.default)("garbage");
var CORRUPTED = (0, _symbol2.default)("corrupted");
var TAGGED = (0, _symbol2.default)("tagged");

var ARGUMENTS_PATTERN = /^\[object Arguments\]$/;
var CLASS_NAME_PATTERN = /^[A-Z][a-zA-Z0-9]+$/;
var DATA_URL_PATTERN = /^data\:[a-z][\-a-z0-9]+\/([a-z][\-a-z0-9]+)(?:\;base64)?\,/;
var EVAL_USAGE_PATTERN = /\beval\(.*?\)|\beval\b/gm;
var FUNCTION_CLASS_USAGE_PATTERN = /\bFunction\(.*?\)|\bFunction\b/gm;
var FLOAT_NUMBER_PATTERN = /\./;
var SYMBOL_PATTERN = /^Symbol\((.*?)\)$/;
var TAG_PATTERN = /^\[([a-zA-Z][\-a-zA-Z0-9]+)\s+[A-Z][a-zA-Z0-9]+(?:\:(.+?))?\]$/;

var DATA_URL_TAG = "data-url-tag";
var DEFAULT_FORMAT = DATA_URL_TAG;
var DEFAULT_DATA_URL_PREFIX = "data:text/@type;base64,";
var EMPTY_STRING = "";var

Meta = function () {(0, _createClass3.default)(Meta, null, [{ key: _hasInstance2.default, value: function value(
		instance) {
			/*;
             	@meta-configuration:
             		{
             			"instance:required": "*"
             		}
             	@end-meta-configuration
             */

			return this.instanceOf(instance, this);
		} }, { key: "instanceOf", value: function instanceOf(

		instance, blueprint) {
			/*;
                        	@meta-configuration:
                        		{
                        			"instance:required": "*",
                        			"blueprint": "function"
                        		}
                        	@end-meta-configuration
                        */

			if (
			typeof instance == "function" &&
			typeof blueprint == "function" &&
			instance.name === blueprint.name ||

			(typeof instance === "undefined" ? "undefined" : (0, _typeof3.default)(instance)) == "object" &&
			instance != null &&
			typeof blueprint == "function" &&
			instance.constructor.name === blueprint.name)
			{
				return true;
			}

			/*;
     	@note:
     		Possibility of instance being garbage.
     			Do not remove this. This is a special procedure.
     	@end-note
     */

			if (instance === GARBAGE) {
				return false;
			}

			if (typeof blueprint != "function") {
				blueprint = this;
			}

			try {
				return new blueprint(GARBAGE).
				__initialize__(instance, blueprint.name).
				instanceOf(blueprint.name);

			} catch (error) {
				return false;
			}
		} }, { key: "create", value: function create(

		blueprint, entity, state) {
			/*;
                             	@meta-configuration:
                             		{
                             			"blueprint:required": "function",
                             			"entity": "*",
                             			"state": Array
                             		}
                             	@end-meta-configuration
                             */

			if (arguments.length == 0) {
				blueprint = this;
				entity = undefined;
				state = [];
			}

			if (arguments.length == 1) {
				blueprint = this;
				entity = arguments[0];
				state = [];
			}

			if (arguments.length == 2) {
				blueprint = arguments[0];
				entity = arguments[1];
				state = [];
			}

			if (typeof blueprint != "function") {
				blueprint = this;
			}

			if ((typeof state === "undefined" ? "undefined" : (0, _typeof3.default)(state)) == "object") {
				state = (0, _from2.default)(state);

			} else {
				state = [];
			}

			/*;
     	@note:
     		If we are going to throw an error here, possibility of infinite recursion.
     			We can push an error instead.
     	@end-note
     */

			if (!(blueprint instanceof this)) {
				state.push(new Error("incompatible blueprint, " + blueprint.name));

				blueprint = this;
			}

			try {
				var data = new blueprint(entity);

				if (TAG_PATTERN.test(data.stringify())) {
					state.push(TAGGED);
				}

				var index = state.length;
				while (index--) {
					var status = state[index];

					if (status instanceof Error) {
						data.setError(status);

					} else {
						harden(status, status, data);
					}
				}

				return (0, _freeze2.default)(data);

			} catch (error) {
				state.push(new Error("cannot wrap data, " + error.stack));

				return Meta.create(this, entity, state);
			}
		}

		/*;
    	@static-method-documentation:
    		Default generic deserialization parser.
    	@end-static-method-documentation
    */ }, { key: "parser", value: function parser(
		data) {
			/*;
         	@meta-configuration:
         		{
         			"data:required": "string"
         		}
         	@end-meta-configuration
         */

			if (typeof data != "string") {
				throw new Error("cannot parse data, " + data);
			}

			try {
				var token = data.match(TAG_PATTERN) || [];
				var type = token[1] || "undefined";
				var value = token[2] || EMPTY_STRING;

				if (value == EMPTY_STRING) {
					value = data;
				}

				/*;
      	@note:
      		If the value is a data url format, try to decode it.
      			Ensure that we have the correct type.
      	@end-note
      */

				if (DATA_URL_PATTERN.test(value)) {
					type = (value.match(DATA_URL_PATTERN) || [])[1] || type;
					value = value.replace(DEFAULT_DATA_URL_PREFIX.replace("@type", type), EMPTY_STRING);
					value = sxty4(value).decode();
				}

				switch (type) {
					case "boolean":
						if (value.toLowerCase() == "true") {
							return true;
						}

						if (value.toLowerCase() == "false") {
							return false;
						}

						throw new Error("cannot parse boolean, " + value);

					case "function":
						try {
							if (EVAL_USAGE_PATTERN.test(value)) {
								throw new Error("cannot parse function, contains eval, potential security issue");
							}

							if (FUNCTION_CLASS_USAGE_PATTERN.test(value)) {
								throw new Error("cannot parse function, contains function class, potential security issue");
							}

							var method = new Function("return " + value)();

							if (typeof method != "function") {
								return function () {throw new Error("no operation done, " + value);};
							}

							return method;

						} catch (error) {
							throw new Error("cannot parse function, " + value + ", " + error.stack);
						}

					case "number":
						try {
							if (value == "Infinity") {
								return Infinity;
							}

							if (value == "NaN") {
								return NaN;
							}

							if (FLOAT_NUMBER_PATTERN.test(value)) {
								return parseFloat(value);
							}

							if (!FLOAT_NUMBER_PATTERN.test(value)) {
								return parseInt(value);
							}

							throw new Error("cannot parse number, " + value);

						} catch (error) {
							throw new Error("cannot parse number, " + value + ", " + error.stack);
						}

					case "object":
						if (value == "null") {
							return null;
						}

						try {
							value = JSON.parse(value);

							/*;
                                  	This is the specification for the basic
                                  		meta object structure.
                                  */
							if (
							"type" in value && typeof value.type == "string" &&
							"name" in value && typeof value.name == "string" &&
							"value" in value && typeof value.value == "string" &&
							"format" in value && typeof value.format == "string" &&
							value.format == DATA_URL_TAG &&
							TAG_PATTERN.test(value.value))
							{
								return Meta.deserialize(value.value).valueOf();
							}

							return value;

						} catch (error) {
							return new Error("cannot parse object, " + value + ", " + error.stack);
						}

					case "string":
						return value;

					case "symbol":
						var symbol = ((value.match(SYMBOL_PATTERN) || [])[1] || EMPTY_STRING).trim();

						if (symbol == EMPTY_STRING) {
							throw new Error("cannot parse symbol, " + value);
						}

						return (0, _symbol2.default)(symbol);

					case "undefined":
						return undefined;}


			} catch (error) {
				throw new Error("cannot parse data, " + data + ", " + error.stack);
			}

			throw new Error("cannot parse data, " + data);
		}

		/*;
    	@static-method-documentation:
    		Generic meta data deserialization.
    	@end-static-method-documentation
    */ }, { key: "deserialize", value: function deserialize(
		data, parser, blueprint) {
			/*;
                            	@meta-configuration:
                            		{
                            			"data": "*",
                            			"parser": "function",
                            			"blueprint": "function"
                            		}
                            	@end-meta-configuration
                            */var _Meta$__deserializeDe =

			Meta.__deserializeDefer__(arguments, this, Meta.parser),_Meta$__deserializeDe2 = (0, _slicedToArray3.default)(_Meta$__deserializeDe, 4),data = _Meta$__deserializeDe2[0],parser = _Meta$__deserializeDe2[1],defer = _Meta$__deserializeDe2[2],blueprint = _Meta$__deserializeDe2[3];

			try {
				return Meta.create(blueprint, parser(data));

			} catch (error) {
				return Meta.create(blueprint, defer(data), [CORRUPTED, error]);
			}
		} }, { key: "__deserializeDefer__", value: function __deserializeDefer__(

		parameter, blueprint, parser) {
			/*;
                                 	@meta-configuration:
                                 		{
                                 			"parameter:required": Arguments,
                                 			"blueprint:required": "function",
                                 			"parser:required": "function"
                                 		}
                                 	@end-meta-configuration
                                 */

			if (!ARGUMENTS_PATTERN.test(parameter)) {
				throw new Error("invalid parameter");
			}

			if (typeof blueprint != "function") {
				throw new Error("invalid blueprint");
			}

			if (typeof parser != "function") {
				throw new Error("invalid parser");
			}

			var argument = parameter;

			try {
				parameter = (0, _from2.default)(parameter);

			} catch (error) {
				throw new Error("cannot process parameter, " + error.stack);
			}

			if (argument.length == 2) {
				parameter = [argument[0], undefined, argument[1]];
			}

			blueprint = parameter.slice(1).
			filter(function (parameter) {
				return (
					typeof parameter == "function" &&
					"name" in parameter &&
					typeof parameter.name == "string" &&
					parameter.name != EMPTY_STRING &&
					CLASS_NAME_PATTERN.test(parameter.name));

			}).
			concat(blueprint)[0];

			var defer = parser;

			parser = parameter.slice(1).
			filter(function (parameter) {
				return (
					typeof parameter == "function" && (

					!("name" in parameter) ||
					typeof parameter.name != "string" ||
					parameter.name == EMPTY_STRING ||
					parameter.name == "anonymous" ||
					parameter.name == "parser"));


			}).
			concat(defer)[0];

			return [parameter[0], parser, defer, blueprint];
		}

		/*;
    	@static-method-documentation:
    		Checks if the tag is compatible.
    	@end-static-method-documentation
    		@note:
    		Override for specific compatibility checking.
    	@end-note
    */ }, { key: "isCompatible", value: function isCompatible(

		tag) {
			/*;
        	@meta-configuration:
        		{
        			"tag": "string"
        		}
        	@end-meta-configuration
        */

			if (typeof tag != "string") {
				return false;
			}

			return TAG_PATTERN.test(tag);
		} }]);

	function Meta(entity, name) {(0, _classCallCheck3.default)(this, Meta);
		/*;
                                                                         	@meta-configuration:
                                                                         		{
                                                                         			"entity:required": "*",
                                                                         			"name:required": "string"
                                                                         		}
                                                                         	@end-meta-configuration
                                                                         */

		this.__initialize__(entity, name);
	}

	/*;
   	@method-documentation:
   		This is an internal initialization procedure.
   
   	@end-method-documentation
   */(0, _createClass3.default)(Meta, [{ key: "__initialize__", value: function __initialize__(

		entity, name) {
			/*;
                 	@meta-configuration:
                 		{
                 			"entity:required": "*",
                 			"name:required": "string"
                 		}
                 	@end-meta-configuration
                 */

			if (!this.check(entity)) {
				throw new Error("invalid entity");
			}

			var type = typeof entity === "undefined" ? "undefined" : (0, _typeof3.default)(entity);

			name = name || type.replace(/^./, function (match) {return match.toUpperCase();});

			if (typeof name != "string") {
				throw new Error("invalid name");
			}

			this[TYPE] = type;
			this[NAME] = name;
			this[ENTITY] = entity;

			this[ERROR] = [];

			return this;
		}

		/*;
    	@method-documentation:
    		For generic checking of entity this is always true,
    			and this should be overridden.
    	@end-method-documentation
    */ }, { key: "check", value: function check(
		entity) {
			return true;
		}

		/*;
    	@method-documentation:
    		This will only support three types; string, number, boolean.
    			These types are serializable.
    	@end-method-documentation
    		@note:
    		Do not override this.
    	@end-note
    */ }, { key: _toPrimitive2.default, value: function value(


		type) {
			/*;
         	@meta-configuration:
         		{
         			"type:required": "string",
         		}
         	@end-meta-configuration
         */

			switch (type) {
				case "string":
					return this.toString();

				case "number":
					return this.toNumber();

				default:
					return this.toBoolean();}

		}

		/*
    	@note:
    		These methods should be overridden.
    	@end-note
    */ }, { key: "tag",

















































		/*;
                        	@method-documentation:
                        		Return a string tag format,
                        				[type Name:value]
                        			The value is optional.
                        	@end-method-documentation
                        */value: function tag(


		value) {
			/*;
          	@meta-configuration:
          		{
          			"value": "string"
          		}
          	@end-meta-configuration
          */

			if (typeof value != "string") {
				value = EMPTY_STRING;
			}

			if (value != EMPTY_STRING) {
				value = ":" + value;
			}

			return ("[" + this.getType() + " " + this.getName() + ":@value]").replace(":@value", value);
		}

		/*;
    	@method-documentation:
    		Returns the object conversion of this data.
    			This will be used on JSON.stringify method.
    	@end-method-documentation
    */ }, { key: "toJSON", value: function toJSON()

		{
			return this[OBJECT];
		}

		/*;
    	@method-documentation:
    		Returns the object conversion of this data.
    	@end-method-documentation
    */ }, { key: "toObject", value: function toObject()
		{
			return this[OBJECT];
		}

		/*;
    	@method-documentation:
    		Returns the boolean conversion of this data.
    	@end-method-documentation
    		@note:
    		As much as possible, do not override this method.
    	@end-note
    */ }, { key: "toBoolean", value: function toBoolean()

		{
			return this[BOOLEAN];
		}

		/*;
    	@method-documentation:
    		Returns the string conversion of this data.
    	@end-method-documentation
    		@note:
    		As much as possible, do not override this method.
    	@end-note
    */ }, { key: "toString", value: function toString()

		{
			return this[STRING];
		}

		/*;
    	@method-documentation:
    		Returns the numerical conversion of this data.
    	@end-method-documentation
    		@note:
    		As much as possible, do not override this method.
    	@end-note
    */ }, { key: "toNumber", value: function toNumber()

		{
			return this[NUMBER];
		}

		/*;
    	@method-documentation:
    		Returns the original value.
    	@end-method-documentation
    		@note:
    		As much as possible, do not override this method.
    	@end-note
    */ }, { key: "valueOf", value: function valueOf()

		{
			return this[VALUE];
		} }, { key: "typeOf", value: function typeOf(

		type) {
			/*;
         	@meta-configuration:
         		{
         			"type:required": "string"
         		}
         	@end-meta-configuration
         */

			if (typeof type == "string") {
				return (0, _typeof3.default)(this.valueOf()) == type;
			}

			return false;
		}

		/*
    	@note:
    		Some cases that instanceOf needs to be overridden.
    	@end-note
    */ }, { key: "instanceOf", value: function instanceOf(
		blueprint) {
			/*;
              	@meta-configuration:
              		{
              			"blueprint:required": [
              				"function",
              				"string"
              			]
              		}
              	@end-meta-configuration
              */

			var entity = this.valueOf();

			if (typeof blueprint == "function") {
				return (
					this instanceof blueprint ||
					entity instanceof blueprint ||
					typeof blueprint.name == "string" && this.instanceOf(blueprint.name));

			}

			if (typeof blueprint == "string") {
				if (this.typeOf(blueprint.toLowerCase())) {
					return true;
				}

				if (entity === null || typeof entity == "undefined") {
					return false;
				}

				if (typeof entity == "function" && entity.name === blueprint) {
					return true;
				}

				do {
					if (
					typeof entity == "function" &&
					entity.name === blueprint ||

					typeof entity.constructor == "function" &&
					entity.constructor.name === blueprint)
					{
						return true;
					}
				} while (entity = (0, _getPrototypeOf2.default)(entity));

				/*;
                                                              	@note:
                                                              		If you removed the condition, this may cause unwanted behavior.
                                                              	@end-note
                                                              */
				if (this.constructor.name != blueprint) {
					var _entity = this;

					do {
						if (
						typeof _entity == "function" &&
						_entity.name === blueprint ||

						typeof _entity.constructor == "function" &&
						_entity.constructor.name === blueprint)
						{
							return true;
						}
					} while (_entity = (0, _getPrototypeOf2.default)(_entity));
				}

				return false;
			}

			return false;
		}

		/*;
    	@note:
    		This is the generic stringify function,
    			for complex entity you need to override this.
    	@end-note
    */ }, { key: "stringify", value: function stringify()
		{
			try {
				if (this.getType() == "object") {
					return (0, _stringify2.default)(this.valueOf());
				}

				return EMPTY_STRING + this.valueOf();

			} catch (error) {
				try {
					return this.valueOf().toString();

				} catch (error) {
					return this.toString();
				}
			}
		}

		/*;
    	@method-documentation:
    		This will call the static deserialization procedure of the constructor.
    	@end-method-documentation
    */ }, { key: "deserialize", value: function deserialize(
		data, parser, blueprint) {
			/*;
                            	@meta-configuration:
                            		{
                            			"data": "*",
                            			"parser": "function",
                            			"blueprint": "function"
                            		}
                            	@end-meta-configuration
                            */

			var procedure = Meta.deserialize;

			if (
			typeof this.constructor == "function" &&
			typeof this.constructor.deserialize == "function" &&
			this.constructor.deserialize.name === "deserialize")
			{
				procedure = this.constructor.deserialize;
			}

			if (arguments.length == 2) {
				return procedure(this.valueOf(), arguments[0], arguments[1]);

			} else {
				return procedure(data, parser, blueprint);
			}
		}

		/*;
    	@static-method-documentation:
    		Default generic serialization interpreter.
    	@end-static-method-documentation
    */ }, { key: "serialize",














		/*;
                              	@method-documentation:
                              		Returns a tag format with value.
                              		The value must be a data URL format.
                              			The interpreter function will accept a context parameter.
                              			By default this will serialize the entity using plain/text base64 data URL format.
                              			The interpreter must return a serialize format of the data to be placed on the tag.
                              	@end-method-documentation
                              */value: function serialize(



		interpreter) {
			/*;
                	@meta-configuration:
                		{
                			"interpreter": "function"
                		}
                	@end-meta-configuration
                */

			var defer = Meta.interpreter;

			if (typeof interpreter != "function") {
				interpreter = defer;
			}

			try {
				return this.tag(interpreter(this));

			} catch (error) {
				return this.tag(defer(this));
			}
		}

		/*;
    	@method-documentation:
    		Strict value equality.
    	@end-method-documentation
    		@note:
    		Override for deep checking.
    	@end-note
    */ }, { key: "isEqual", value: function isEqual(

		entity) {
			/*;
           	@meta-configuration:
           		{
           			"entity:required": "*"
           		}
           	@end-meta-configuration
           */

			if (entity instanceof Meta) {
				return this.valueOf() === entity.valueOf();
			}

			return this.valueOf() === entity;
		}

		/*;
    	@method-documentation:
    		When the deserialization fails, or if there is error, this method returns true.
    	@end-method-documentation
    */ }, { key: "isCorrupted", value: function isCorrupted()
		{
			return (
				this[CORRUPTED] === CORRUPTED ||
				this.hasError());

		} }, { key: "isTagged", value: function isTagged()

		{
			return (
				this[TAGGED] === TAGGED ||
				TAG_PATTERN.test(this.stringify()));

		}

		/*;
    	@method-documentation:
    		If the entity is not a tag format then it's raw.
    	@end-method-documentation
    */ }, { key: "isRaw", value: function isRaw()
		{
			return !this.isTagged();
		} }, { key: "setError", value: function setError(

		error) {
			if (error instanceof Error) {
				this.pushError(error);
			}

			return this;
		} }, { key: "pushError", value: function pushError(

		error) {
			if (error instanceof Error) {
				this[ERROR].push(error);
			}

			return this;
		} }, { key: "getError", value: function getError()

		{
			return this[ERROR].reverse()[0];
		} }, { key: "hasError", value: function hasError()

		{
			return this[ERROR].length > 0;
		} }, { key: "transferError", value: function transferError(

		container) {
			/*;
              	@meta-configuration:
              		{
              			"container": Array
              		}
              	@end-meta-configuration
              */

			if (container instanceof Array) {
				var list = this[ERROR].reverse();
				var index = list.length;
				while (index--) {container.push(list[index]);}
			}

			return this;
		}

		/*;
    	@method-documentation:
    		Returns the clone of this data.
    	@end-method-documentation
    */ }, { key: "clone", value: function clone(
		state) {
			/*;
          	@meta-configuration:
          		{
          			"state": Array
          		}
          	@end-meta-configuration
          */

			return Meta.create(this.constructor, this.valueOf(), state);
		}

		/*;
    	@method-documentation:
    		Returns the Meta instance of this data.
    	@end-method-documentation
    */ }, { key: "native", value: function native(
		state) {
			/*;
          	@meta-configuration:
          		{
          			"state": Array
          		}
          	@end-meta-configuration
          */

			return Meta.create(Meta, this.valueOf(), state);
		}

		/*;
    	@method-documentation:
    		Reverts to the Meta instance of this data,
    			passing the incurred state from previous.
    	@end-method-documentation
    */ }, { key: "revert", value: function revert()
		{
			var state = [];

			if (this.isCorrupted()) {
				state.push(CORRUPTED);
			}

			if (this.hasError()) {
				this.transferError(state);
			}

			return this.native(state);
		} }, { key: "getType", value: function getType()

		{
			return this[TYPE];
		} }, { key: "getName", value: function getName()

		{
			return this[NAME];
		} }, { key: _toStringTag2.default, get: function get() {return this.getName();} /*;
                                                                                  	@method-documentation:
                                                                                  		Generally, this will return the basic object meta specification.
                                                                                  			The format property dictates how the value must be interpreted.
                                                                                  	@end-method-documentation
                                                                                  		@note:
                                                                                  		For special values that needs specific conversion to object type,
                                                                                  			this method needs to be overridden.
                                                                                  	@end-note
                                                                                  */ }, { key: OBJECT, get: function get() {return (0, _freeze2.default)({ "type": this.getType(), "name": this.getName(), "value": this.serialize(), "format": DATA_URL_TAG });} }, { key: BOOLEAN, get: function get() {return true;} }, { key: STRING, get: function get() {return Object.prototype.toString.call(this.valueOf());} }, { key: NUMBER, get: function get() {return Infinity;} /*;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                	@get-method-documentation:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                		Returns the original value.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                			As much as possible do not override this.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                	@end-get-method-documentation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */ }, { key: VALUE, get: function get() {return this[ENTITY];} }], [{ key: "interpreter", value: function interpreter(self) {/*;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             	@meta-configuration:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		{
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             			"self": Meta
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             		}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             	@end-meta-configuration
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             */var value = sxty4(self.stringify()).encode();return "" + DEFAULT_DATA_URL_PREFIX.replace("@type", self.getType()) + value;} }]);return Meta;}();harden("NAME", NAME, Meta);harden("ENTITY", ENTITY, Meta);harden("TYPE", TYPE, Meta);harden("OBJECT", OBJECT, Meta);harden("BOOLEAN", BOOLEAN, Meta);harden("STRING", STRING, Meta);harden("NUMBER", NUMBER, Meta);harden("VALUE", VALUE, Meta);harden("GARBAGE", GARBAGE, Meta);harden("CORRUPTED", CORRUPTED, Meta);harden("TAGGED", TAGGED, Meta);harden("TAG_PATTERN", TAG_PATTERN, Meta);harden("DATA_URL_TAG", DATA_URL_TAG, Meta);
module.exports = Meta;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1ldGEuc3VwcG9ydC5qcyJdLCJuYW1lcyI6WyJoYXJkZW4iLCJyZXF1aXJlIiwic3h0eTQiLCJOQU1FIiwiRU5USVRZIiwiVFlQRSIsIkVSUk9SIiwiT0JKRUNUIiwiQk9PTEVBTiIsIlNUUklORyIsIk5VTUJFUiIsIlZBTFVFIiwiR0FSQkFHRSIsIkNPUlJVUFRFRCIsIlRBR0dFRCIsIkFSR1VNRU5UU19QQVRURVJOIiwiQ0xBU1NfTkFNRV9QQVRURVJOIiwiREFUQV9VUkxfUEFUVEVSTiIsIkVWQUxfVVNBR0VfUEFUVEVSTiIsIkZVTkNUSU9OX0NMQVNTX1VTQUdFX1BBVFRFUk4iLCJGTE9BVF9OVU1CRVJfUEFUVEVSTiIsIlNZTUJPTF9QQVRURVJOIiwiVEFHX1BBVFRFUk4iLCJEQVRBX1VSTF9UQUciLCJERUZBVUxUX0ZPUk1BVCIsIkRFRkFVTFRfREFUQV9VUkxfUFJFRklYIiwiRU1QVFlfU1RSSU5HIiwiTWV0YSIsImluc3RhbmNlIiwiaW5zdGFuY2VPZiIsImJsdWVwcmludCIsIm5hbWUiLCJjb25zdHJ1Y3RvciIsIl9faW5pdGlhbGl6ZV9fIiwiZXJyb3IiLCJlbnRpdHkiLCJzdGF0ZSIsImFyZ3VtZW50cyIsImxlbmd0aCIsInVuZGVmaW5lZCIsInB1c2giLCJFcnJvciIsImRhdGEiLCJ0ZXN0Iiwic3RyaW5naWZ5IiwiaW5kZXgiLCJzdGF0dXMiLCJzZXRFcnJvciIsInN0YWNrIiwiY3JlYXRlIiwidG9rZW4iLCJtYXRjaCIsInR5cGUiLCJ2YWx1ZSIsInJlcGxhY2UiLCJkZWNvZGUiLCJ0b0xvd2VyQ2FzZSIsIm1ldGhvZCIsIkZ1bmN0aW9uIiwiSW5maW5pdHkiLCJOYU4iLCJwYXJzZUZsb2F0IiwicGFyc2VJbnQiLCJKU09OIiwicGFyc2UiLCJmb3JtYXQiLCJkZXNlcmlhbGl6ZSIsInZhbHVlT2YiLCJzeW1ib2wiLCJ0cmltIiwicGFyc2VyIiwiX19kZXNlcmlhbGl6ZURlZmVyX18iLCJkZWZlciIsInBhcmFtZXRlciIsImFyZ3VtZW50Iiwic2xpY2UiLCJmaWx0ZXIiLCJjb25jYXQiLCJ0YWciLCJjaGVjayIsInRvVXBwZXJDYXNlIiwidG9TdHJpbmciLCJ0b051bWJlciIsInRvQm9vbGVhbiIsImdldFR5cGUiLCJnZXROYW1lIiwidHlwZU9mIiwicHJvY2VkdXJlIiwiaW50ZXJwcmV0ZXIiLCJoYXNFcnJvciIsImlzVGFnZ2VkIiwicHVzaEVycm9yIiwicmV2ZXJzZSIsImNvbnRhaW5lciIsIkFycmF5IiwibGlzdCIsImlzQ29ycnVwdGVkIiwidHJhbnNmZXJFcnJvciIsIm5hdGl2ZSIsInNlcmlhbGl6ZSIsIk9iamVjdCIsInByb3RvdHlwZSIsImNhbGwiLCJzZWxmIiwiZW5jb2RlIiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6IkFBQUE7O0FBRUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUF1REEsSUFBTUEsU0FBU0MsUUFBUyxRQUFULENBQWY7QUFDQSxJQUFNQyxRQUFRRCxRQUFTLE9BQVQsQ0FBZDs7QUFFQSxJQUFNRSxPQUFPLHNCQUFRLE1BQVIsQ0FBYjtBQUNBLElBQU1DLFNBQVMsc0JBQVEsUUFBUixDQUFmO0FBQ0EsSUFBTUMsT0FBTyxzQkFBUSxNQUFSLENBQWI7O0FBRUEsSUFBTUMsUUFBUSxzQkFBUSxPQUFSLENBQWQ7O0FBRUEsSUFBTUMsU0FBUyxzQkFBUSxRQUFSLENBQWY7QUFDQSxJQUFNQyxVQUFVLHNCQUFRLFNBQVIsQ0FBaEI7QUFDQSxJQUFNQyxTQUFTLHNCQUFRLFFBQVIsQ0FBZjtBQUNBLElBQU1DLFNBQVMsc0JBQVEsUUFBUixDQUFmO0FBQ0EsSUFBTUMsUUFBUSxzQkFBUSxPQUFSLENBQWQ7O0FBRUEsSUFBTUMsVUFBVSxzQkFBUSxTQUFSLENBQWhCO0FBQ0EsSUFBTUMsWUFBWSxzQkFBUSxXQUFSLENBQWxCO0FBQ0EsSUFBTUMsU0FBUyxzQkFBUSxRQUFSLENBQWY7O0FBRUEsSUFBTUMsb0JBQW9CLHdCQUExQjtBQUNBLElBQU1DLHFCQUFxQixxQkFBM0I7QUFDQSxJQUFNQyxtQkFBbUIsNERBQXpCO0FBQ0EsSUFBTUMscUJBQXFCLDBCQUEzQjtBQUNBLElBQU1DLCtCQUErQixrQ0FBckM7QUFDQSxJQUFNQyx1QkFBdUIsSUFBN0I7QUFDQSxJQUFNQyxpQkFBaUIsbUJBQXZCO0FBQ0EsSUFBTUMsY0FBYyxnRUFBcEI7O0FBRUEsSUFBTUMsZUFBZSxjQUFyQjtBQUNBLElBQU1DLGlCQUFpQkQsWUFBdkI7QUFDQSxJQUFNRSwwQkFBMEIseUJBQWhDO0FBQ0EsSUFBTUMsZUFBZSxFQUFyQixDOztBQUVNQyxJO0FBQzBCQyxVLEVBQVU7QUFDeEM7Ozs7Ozs7O0FBUUEsVUFBTyxLQUFLQyxVQUFMLENBQWlCRCxRQUFqQixFQUEyQixJQUEzQixDQUFQO0FBQ0EsRzs7QUFFa0JBLFUsRUFBVUUsUyxFQUFXO0FBQ3ZDOzs7Ozs7Ozs7QUFTQTtBQUNDLFVBQU9GLFFBQVAsSUFBbUIsVUFBbkI7QUFDRyxVQUFPRSxTQUFQLElBQW9CLFVBRHZCO0FBRUdGLFlBQVNHLElBQVQsS0FBa0JELFVBQVVDLElBSDVCOztBQUtILFdBQU9ILFFBQVAsdURBQU9BLFFBQVAsTUFBbUIsUUFBbkI7QUFDR0EsZUFBWSxJQURmO0FBRUcsVUFBT0UsU0FBUCxJQUFvQixVQUZ2QjtBQUdHRixZQUFTSSxXQUFULENBQXFCRCxJQUFyQixLQUE4QkQsVUFBVUMsSUFSNUM7QUFTRztBQUNGLFdBQU8sSUFBUDtBQUNBOztBQUVEOzs7Ozs7O0FBT0EsT0FBSUgsYUFBYWhCLE9BQWpCLEVBQTBCO0FBQ3pCLFdBQU8sS0FBUDtBQUNBOztBQUVELE9BQUksT0FBT2tCLFNBQVAsSUFBb0IsVUFBeEIsRUFBb0M7QUFDbkNBLGdCQUFZLElBQVo7QUFDQTs7QUFFRCxPQUFHO0FBQ0YsV0FBUyxJQUFJQSxTQUFKLENBQWVsQixPQUFmLENBQUY7QUFDTHFCLGtCQURLLENBQ1dMLFFBRFgsRUFDcUJFLFVBQVVDLElBRC9CO0FBRUxGLGNBRkssQ0FFT0MsVUFBVUMsSUFGakIsQ0FBUDs7QUFJQSxJQUxELENBS0MsT0FBT0csS0FBUCxFQUFjO0FBQ2QsV0FBTyxLQUFQO0FBQ0E7QUFDRCxHOztBQUVjSixXLEVBQVdLLE0sRUFBUUMsSyxFQUFPO0FBQ3hDOzs7Ozs7Ozs7O0FBVUEsT0FBSUMsVUFBVUMsTUFBVixJQUFvQixDQUF4QixFQUEyQjtBQUMxQlIsZ0JBQVksSUFBWjtBQUNBSyxhQUFTSSxTQUFUO0FBQ0FILFlBQVEsRUFBUjtBQUNBOztBQUVELE9BQUlDLFVBQVVDLE1BQVYsSUFBb0IsQ0FBeEIsRUFBMkI7QUFDMUJSLGdCQUFZLElBQVo7QUFDQUssYUFBU0UsVUFBVyxDQUFYLENBQVQ7QUFDQUQsWUFBUSxFQUFSO0FBQ0E7O0FBRUQsT0FBSUMsVUFBVUMsTUFBVixJQUFvQixDQUF4QixFQUEyQjtBQUMxQlIsZ0JBQVlPLFVBQVcsQ0FBWCxDQUFaO0FBQ0FGLGFBQVNFLFVBQVcsQ0FBWCxDQUFUO0FBQ0FELFlBQVEsRUFBUjtBQUNBOztBQUVELE9BQUksT0FBT04sU0FBUCxJQUFvQixVQUF4QixFQUFvQztBQUNuQ0EsZ0JBQVksSUFBWjtBQUNBOztBQUVELE9BQUksUUFBT00sS0FBUCx1REFBT0EsS0FBUCxNQUFnQixRQUFwQixFQUE4QjtBQUM3QkEsWUFBUSxvQkFBWUEsS0FBWixDQUFSOztBQUVBLElBSEQsTUFHSztBQUNKQSxZQUFRLEVBQVI7QUFDQTs7QUFFRDs7Ozs7OztBQU9BLE9BQUksRUFBR04scUJBQXFCLElBQXhCLENBQUosRUFBb0M7QUFDbkNNLFVBQU1JLElBQU4sQ0FBWSxJQUFJQyxLQUFKLDhCQUF1Q1gsVUFBVUMsSUFBakQsQ0FBWjs7QUFFQUQsZ0JBQVksSUFBWjtBQUNBOztBQUVELE9BQUc7QUFDRixRQUFJWSxPQUFPLElBQUlaLFNBQUosQ0FBZUssTUFBZixDQUFYOztBQUVBLFFBQUliLFlBQVlxQixJQUFaLENBQWtCRCxLQUFLRSxTQUFMLEVBQWxCLENBQUosRUFBMkM7QUFDMUNSLFdBQU1JLElBQU4sQ0FBWTFCLE1BQVo7QUFDQTs7QUFFRCxRQUFJK0IsUUFBUVQsTUFBTUUsTUFBbEI7QUFDQSxXQUFPTyxPQUFQLEVBQWdCO0FBQ2YsU0FBSUMsU0FBU1YsTUFBT1MsS0FBUCxDQUFiOztBQUVBLFNBQUlDLGtCQUFrQkwsS0FBdEIsRUFBNkI7QUFDNUJDLFdBQUtLLFFBQUwsQ0FBZUQsTUFBZjs7QUFFQSxNQUhELE1BR0s7QUFDSjlDLGFBQVE4QyxNQUFSLEVBQWdCQSxNQUFoQixFQUF3QkosSUFBeEI7QUFDQTtBQUNEOztBQUVELFdBQU8sc0JBQWVBLElBQWYsQ0FBUDs7QUFFQSxJQXJCRCxDQXFCQyxPQUFPUixLQUFQLEVBQWM7QUFDZEUsVUFBTUksSUFBTixDQUFZLElBQUlDLEtBQUosd0JBQWlDUCxNQUFNYyxLQUF2QyxDQUFaOztBQUVBLFdBQU9yQixLQUFLc0IsTUFBTCxDQUFhLElBQWIsRUFBbUJkLE1BQW5CLEVBQTJCQyxLQUEzQixDQUFQO0FBQ0E7QUFDRDs7QUFFRDs7Ozs7QUFLZU0sTSxFQUFNO0FBQ3BCOzs7Ozs7OztBQVFBLE9BQUksT0FBT0EsSUFBUCxJQUFlLFFBQW5CLEVBQTZCO0FBQzVCLFVBQU0sSUFBSUQsS0FBSix5QkFBa0NDLElBQWxDLENBQU47QUFDQTs7QUFFRCxPQUFHO0FBQ0YsUUFBSVEsUUFBUVIsS0FBS1MsS0FBTCxDQUFZN0IsV0FBWixLQUE2QixFQUF6QztBQUNBLFFBQUk4QixPQUFPRixNQUFPLENBQVAsS0FBYyxXQUF6QjtBQUNBLFFBQUlHLFFBQVFILE1BQU8sQ0FBUCxLQUFjeEIsWUFBMUI7O0FBRUEsUUFBSTJCLFNBQVMzQixZQUFiLEVBQTJCO0FBQzFCMkIsYUFBUVgsSUFBUjtBQUNBOztBQUVEOzs7Ozs7O0FBT0EsUUFBSXpCLGlCQUFpQjBCLElBQWpCLENBQXVCVSxLQUF2QixDQUFKLEVBQW9DO0FBQ25DRCxZQUFPLENBQUVDLE1BQU1GLEtBQU4sQ0FBYWxDLGdCQUFiLEtBQW1DLEVBQXJDLEVBQTRDLENBQTVDLEtBQW1EbUMsSUFBMUQ7QUFDQUMsYUFBUUEsTUFBTUMsT0FBTixDQUFlN0Isd0JBQXdCNkIsT0FBeEIsQ0FBaUMsT0FBakMsRUFBMENGLElBQTFDLENBQWYsRUFBaUUxQixZQUFqRSxDQUFSO0FBQ0EyQixhQUFRbkQsTUFBT21ELEtBQVAsRUFBZUUsTUFBZixFQUFSO0FBQ0E7O0FBRUQsWUFBUUgsSUFBUjtBQUNDLFVBQUssU0FBTDtBQUNDLFVBQUlDLE1BQU1HLFdBQU4sTUFBd0IsTUFBNUIsRUFBb0M7QUFDbkMsY0FBTyxJQUFQO0FBQ0E7O0FBRUQsVUFBSUgsTUFBTUcsV0FBTixNQUF3QixPQUE1QixFQUFxQztBQUNwQyxjQUFPLEtBQVA7QUFDQTs7QUFFRCxZQUFNLElBQUlmLEtBQUosNEJBQXFDWSxLQUFyQyxDQUFOOztBQUVELFVBQUssVUFBTDtBQUNDLFVBQUc7QUFDRixXQUFJbkMsbUJBQW1CeUIsSUFBbkIsQ0FBeUJVLEtBQXpCLENBQUosRUFBc0M7QUFDckMsY0FBTSxJQUFJWixLQUFKLENBQVcsZ0VBQVgsQ0FBTjtBQUNBOztBQUVELFdBQUl0Qiw2QkFBNkJ3QixJQUE3QixDQUFtQ1UsS0FBbkMsQ0FBSixFQUFnRDtBQUMvQyxjQUFNLElBQUlaLEtBQUosQ0FBVywwRUFBWCxDQUFOO0FBQ0E7O0FBRUQsV0FBSWdCLFNBQVcsSUFBSUMsUUFBSixDQUFjLFlBQVlMLEtBQTFCLENBQUYsRUFBYjs7QUFFQSxXQUFJLE9BQU9JLE1BQVAsSUFBaUIsVUFBckIsRUFBaUM7QUFDaEMsZUFBTyxZQUFXLENBQUUsTUFBTSxJQUFJaEIsS0FBSix5QkFBa0NZLEtBQWxDLENBQU4sQ0FBcUQsQ0FBekU7QUFDQTs7QUFFRCxjQUFPSSxNQUFQOztBQUVBLE9BakJELENBaUJDLE9BQU92QixLQUFQLEVBQWM7QUFDZCxhQUFNLElBQUlPLEtBQUosNkJBQXNDWSxLQUF0QyxVQUFrRG5CLE1BQU1jLEtBQXhELENBQU47QUFDQTs7QUFFRixVQUFLLFFBQUw7QUFDQyxVQUFHO0FBQ0YsV0FBSUssU0FBUyxVQUFiLEVBQXlCO0FBQ3hCLGVBQU9NLFFBQVA7QUFDQTs7QUFFRCxXQUFJTixTQUFTLEtBQWIsRUFBb0I7QUFDbkIsZUFBT08sR0FBUDtBQUNBOztBQUVELFdBQUl4QyxxQkFBcUJ1QixJQUFyQixDQUEyQlUsS0FBM0IsQ0FBSixFQUF3QztBQUN2QyxlQUFPUSxXQUFZUixLQUFaLENBQVA7QUFDQTs7QUFFRCxXQUFJLENBQUNqQyxxQkFBcUJ1QixJQUFyQixDQUEyQlUsS0FBM0IsQ0FBTCxFQUF5QztBQUN4QyxlQUFPUyxTQUFVVCxLQUFWLENBQVA7QUFDQTs7QUFFRCxhQUFNLElBQUlaLEtBQUosMkJBQW9DWSxLQUFwQyxDQUFOOztBQUVBLE9BbkJELENBbUJDLE9BQU9uQixLQUFQLEVBQWM7QUFDZCxhQUFNLElBQUlPLEtBQUosMkJBQW9DWSxLQUFwQyxVQUFnRG5CLE1BQU1jLEtBQXRELENBQU47QUFDQTs7QUFFRixVQUFLLFFBQUw7QUFDQyxVQUFJSyxTQUFTLE1BQWIsRUFBcUI7QUFDcEIsY0FBTyxJQUFQO0FBQ0E7O0FBRUQsVUFBRztBQUNGQSxlQUFRVSxLQUFLQyxLQUFMLENBQVlYLEtBQVosQ0FBUjs7QUFFQTs7OztBQUlBO0FBQ0MsaUJBQVVBLEtBQVYsSUFBbUIsT0FBT0EsTUFBTUQsSUFBYixJQUFxQixRQUF4QztBQUNHLGlCQUFVQyxLQURiLElBQ3NCLE9BQU9BLE1BQU10QixJQUFiLElBQXFCLFFBRDNDO0FBRUcsa0JBQVdzQixLQUZkLElBRXVCLE9BQU9BLE1BQU1BLEtBQWIsSUFBc0IsUUFGN0M7QUFHRyxtQkFBWUEsS0FIZixJQUd3QixPQUFPQSxNQUFNWSxNQUFiLElBQXVCLFFBSC9DO0FBSUdaLGFBQU1ZLE1BQU4sSUFBZ0IxQyxZQUpuQjtBQUtHRCxtQkFBWXFCLElBQVosQ0FBa0JVLE1BQU1BLEtBQXhCLENBTko7QUFPQztBQUNBLGVBQU8xQixLQUFLdUMsV0FBTCxDQUFrQmIsTUFBTUEsS0FBeEIsRUFBZ0NjLE9BQWhDLEVBQVA7QUFDQTs7QUFFRCxjQUFPZCxLQUFQOztBQUVBLE9BcEJELENBb0JDLE9BQU9uQixLQUFQLEVBQWM7QUFDZCxjQUFPLElBQUlPLEtBQUosMkJBQW9DWSxLQUFwQyxVQUFnRG5CLE1BQU1jLEtBQXRELENBQVA7QUFDQTs7QUFFRixVQUFLLFFBQUw7QUFDQyxhQUFPSyxLQUFQOztBQUVELFVBQUssUUFBTDtBQUNDLFVBQUllLFNBQVMsQ0FBRSxDQUFFZixNQUFNRixLQUFOLENBQWE5QixjQUFiLEtBQWlDLEVBQW5DLEVBQTBDLENBQTFDLEtBQWlESyxZQUFuRCxFQUFrRTJDLElBQWxFLEVBQWI7O0FBRUEsVUFBSUQsVUFBVTFDLFlBQWQsRUFBNEI7QUFDM0IsYUFBTSxJQUFJZSxLQUFKLDJCQUFvQ1ksS0FBcEMsQ0FBTjtBQUNBOztBQUVELGFBQU8sc0JBQVFlLE1BQVIsQ0FBUDs7QUFFRCxVQUFLLFdBQUw7QUFDQyxhQUFPN0IsU0FBUCxDQXBHRjs7O0FBdUdBLElBN0hELENBNkhDLE9BQU9MLEtBQVAsRUFBYztBQUNkLFVBQU0sSUFBSU8sS0FBSix5QkFBa0NDLElBQWxDLFVBQTZDUixNQUFNYyxLQUFuRCxDQUFOO0FBQ0E7O0FBRUQsU0FBTSxJQUFJUCxLQUFKLHlCQUFrQ0MsSUFBbEMsQ0FBTjtBQUNBOztBQUVEOzs7OztBQUtvQkEsTSxFQUFNNEIsTSxFQUFReEMsUyxFQUFXO0FBQzVDOzs7Ozs7Ozs4QkFENEM7O0FBV0hILFFBQUs0QyxvQkFBTCxDQUEyQmxDLFNBQTNCLEVBQXNDLElBQXRDLEVBQTRDVixLQUFLMkMsTUFBakQsQ0FYRyxpRkFXdEM1QixJQVhzQyw2QkFXaEM0QixNQVhnQyw2QkFXeEJFLEtBWHdCLDZCQVdqQjFDLFNBWGlCOztBQWE1QyxPQUFHO0FBQ0YsV0FBT0gsS0FBS3NCLE1BQUwsQ0FBYW5CLFNBQWIsRUFBd0J3QyxPQUFRNUIsSUFBUixDQUF4QixDQUFQOztBQUVBLElBSEQsQ0FHQyxPQUFPUixLQUFQLEVBQWM7QUFDZCxXQUFPUCxLQUFLc0IsTUFBTCxDQUFhbkIsU0FBYixFQUF3QjBDLE1BQU85QixJQUFQLENBQXhCLEVBQXVDLENBQUU3QixTQUFGLEVBQWFxQixLQUFiLENBQXZDLENBQVA7QUFDQTtBQUNELEc7O0FBRTRCdUMsVyxFQUFXM0MsUyxFQUFXd0MsTSxFQUFRO0FBQzFEOzs7Ozs7Ozs7O0FBVUEsT0FBSSxDQUFDdkQsa0JBQWtCNEIsSUFBbEIsQ0FBd0I4QixTQUF4QixDQUFMLEVBQTBDO0FBQ3pDLFVBQU0sSUFBSWhDLEtBQUosQ0FBVyxtQkFBWCxDQUFOO0FBQ0E7O0FBRUQsT0FBSSxPQUFPWCxTQUFQLElBQW9CLFVBQXhCLEVBQW9DO0FBQ25DLFVBQU0sSUFBSVcsS0FBSixDQUFXLG1CQUFYLENBQU47QUFDQTs7QUFFRCxPQUFJLE9BQU82QixNQUFQLElBQWlCLFVBQXJCLEVBQWlDO0FBQ2hDLFVBQU0sSUFBSTdCLEtBQUosQ0FBVyxnQkFBWCxDQUFOO0FBQ0E7O0FBRUQsT0FBSWlDLFdBQVdELFNBQWY7O0FBRUEsT0FBRztBQUNGQSxnQkFBWSxvQkFBWUEsU0FBWixDQUFaOztBQUVBLElBSEQsQ0FHQyxPQUFPdkMsS0FBUCxFQUFjO0FBQ2QsVUFBTSxJQUFJTyxLQUFKLGdDQUF5Q1AsTUFBTWMsS0FBL0MsQ0FBTjtBQUNBOztBQUVELE9BQUkwQixTQUFTcEMsTUFBVCxJQUFtQixDQUF2QixFQUEwQjtBQUN6Qm1DLGdCQUFZLENBQUVDLFNBQVUsQ0FBVixDQUFGLEVBQWlCbkMsU0FBakIsRUFBNEJtQyxTQUFVLENBQVYsQ0FBNUIsQ0FBWjtBQUNBOztBQUVENUMsZUFBWTJDLFVBQVVFLEtBQVYsQ0FBaUIsQ0FBakI7QUFDVkMsU0FEVSxDQUNGLFVBQUVILFNBQUYsRUFBaUI7QUFDekI7QUFDQyxZQUFPQSxTQUFQLElBQW9CLFVBQXBCO0FBQ0csZUFBVUEsU0FEYjtBQUVHLFlBQU9BLFVBQVUxQyxJQUFqQixJQUF5QixRQUY1QjtBQUdHMEMsZUFBVTFDLElBQVYsSUFBa0JMLFlBSHJCO0FBSUdWLHdCQUFtQjJCLElBQW5CLENBQXlCOEIsVUFBVTFDLElBQW5DLENBTEo7O0FBT0EsSUFUVTtBQVVWOEMsU0FWVSxDQVVGL0MsU0FWRSxFQVVXLENBVlgsQ0FBWjs7QUFZQSxPQUFJMEMsUUFBUUYsTUFBWjs7QUFFQUEsWUFBU0csVUFBVUUsS0FBVixDQUFpQixDQUFqQjtBQUNQQyxTQURPLENBQ0MsVUFBRUgsU0FBRixFQUFpQjtBQUN6QjtBQUNDLFlBQU9BLFNBQVAsSUFBb0IsVUFBcEI7O0FBRUMsT0FBRyxVQUFVQSxTQUFiO0FBQ0csWUFBT0EsVUFBVTFDLElBQWpCLElBQXlCLFFBRDVCO0FBRUcwQyxlQUFVMUMsSUFBVixJQUFrQkwsWUFGckI7QUFHRytDLGVBQVUxQyxJQUFWLElBQWtCLFdBSHJCO0FBSUcwQyxlQUFVMUMsSUFBVixJQUFrQixRQU50QixDQUREOzs7QUFVQSxJQVpPO0FBYVA4QyxTQWJPLENBYUNMLEtBYkQsRUFhVSxDQWJWLENBQVQ7O0FBZUEsVUFBTyxDQUFFQyxVQUFXLENBQVgsQ0FBRixFQUFrQkgsTUFBbEIsRUFBMEJFLEtBQTFCLEVBQWlDMUMsU0FBakMsQ0FBUDtBQUNBOztBQUVEOzs7Ozs7Ozs7QUFTcUJnRCxLLEVBQUs7QUFDekI7Ozs7Ozs7O0FBUUEsT0FBSSxPQUFPQSxHQUFQLElBQWMsUUFBbEIsRUFBNEI7QUFDM0IsV0FBTyxLQUFQO0FBQ0E7O0FBRUQsVUFBT3hELFlBQVlxQixJQUFaLENBQWtCbUMsR0FBbEIsQ0FBUDtBQUNBLEc7O0FBRUQsZUFBYTNDLE1BQWIsRUFBcUJKLElBQXJCLEVBQTJCO0FBQzFCOzs7Ozs7Ozs7QUFTQSxPQUFLRSxjQUFMLENBQXFCRSxNQUFyQixFQUE2QkosSUFBN0I7QUFDQTs7QUFFRDs7Ozs7OztBQU9nQkksUSxFQUFRSixJLEVBQU07QUFDN0I7Ozs7Ozs7OztBQVNBLE9BQUksQ0FBQyxLQUFLZ0QsS0FBTCxDQUFZNUMsTUFBWixDQUFMLEVBQTJCO0FBQzFCLFVBQU0sSUFBSU0sS0FBSixDQUFXLGdCQUFYLENBQU47QUFDQTs7QUFFRCxPQUFJVyxjQUFjakIsTUFBZCx1REFBY0EsTUFBZCxDQUFKOztBQUVBSixVQUFPQSxRQUFRcUIsS0FBS0UsT0FBTCxDQUFjLElBQWQsRUFBb0IsVUFBRUgsS0FBRixVQUFhQSxNQUFNNkIsV0FBTixFQUFiLEVBQXBCLENBQWY7O0FBRUEsT0FBSSxPQUFPakQsSUFBUCxJQUFlLFFBQW5CLEVBQTZCO0FBQzVCLFVBQU0sSUFBSVUsS0FBSixDQUFXLGNBQVgsQ0FBTjtBQUNBOztBQUVELFFBQU1wQyxJQUFOLElBQWUrQyxJQUFmO0FBQ0EsUUFBTWpELElBQU4sSUFBZTRCLElBQWY7QUFDQSxRQUFNM0IsTUFBTixJQUFpQitCLE1BQWpCOztBQUVBLFFBQU03QixLQUFOLElBQWdCLEVBQWhCOztBQUVBLFVBQU8sSUFBUDtBQUNBOztBQUVEOzs7Ozs7QUFNTzZCLFEsRUFBUTtBQUNkLFVBQU8sSUFBUDtBQUNBOztBQUVEOzs7Ozs7Ozs7OztBQVd3QmlCLE0sRUFBTTtBQUM3Qjs7Ozs7Ozs7QUFRQSxXQUFRQSxJQUFSO0FBQ0MsU0FBSyxRQUFMO0FBQ0MsWUFBTyxLQUFLNkIsUUFBTCxFQUFQOztBQUVELFNBQUssUUFBTDtBQUNDLFlBQU8sS0FBS0MsUUFBTCxFQUFQOztBQUVEO0FBQ0MsWUFBTyxLQUFLQyxTQUFMLEVBQVAsQ0FSRjs7QUFVQTs7QUFFRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBc0RBOzs7Ozs7Ozs7QUFTSzlCLE8sRUFBTztBQUNYOzs7Ozs7OztBQVFBLE9BQUksT0FBT0EsS0FBUCxJQUFnQixRQUFwQixFQUE4QjtBQUM3QkEsWUFBUTNCLFlBQVI7QUFDQTs7QUFFRCxPQUFJMkIsU0FBUzNCLFlBQWIsRUFBMkI7QUFDMUIyQixrQkFBYUEsS0FBYjtBQUNBOztBQUVELFVBQU8sT0FBSyxLQUFLK0IsT0FBTCxFQUFMLFNBQTBCLEtBQUtDLE9BQUwsRUFBMUIsZUFBcUQvQixPQUFyRCxDQUE4RCxTQUE5RCxFQUF5RUQsS0FBekUsQ0FBUDtBQUNBOztBQUVEOzs7Ozs7O0FBT1M7QUFDUixVQUFPLEtBQU05QyxNQUFOLENBQVA7QUFDQTs7QUFFRDs7Ozs7QUFLVztBQUNWLFVBQU8sS0FBTUEsTUFBTixDQUFQO0FBQ0E7O0FBRUQ7Ozs7Ozs7OztBQVNZO0FBQ1gsVUFBTyxLQUFNQyxPQUFOLENBQVA7QUFDQTs7QUFFRDs7Ozs7Ozs7O0FBU1c7QUFDVixVQUFPLEtBQU1DLE1BQU4sQ0FBUDtBQUNBOztBQUVEOzs7Ozs7Ozs7QUFTVztBQUNWLFVBQU8sS0FBTUMsTUFBTixDQUFQO0FBQ0E7O0FBRUQ7Ozs7Ozs7OztBQVNVO0FBQ1QsVUFBTyxLQUFNQyxLQUFOLENBQVA7QUFDQSxHOztBQUVPeUMsTSxFQUFNO0FBQ2I7Ozs7Ozs7O0FBUUEsT0FBSSxPQUFPQSxJQUFQLElBQWUsUUFBbkIsRUFBNkI7QUFDNUIsV0FBTyxzQkFBTyxLQUFLZSxPQUFMLEVBQVAsS0FBMEJmLElBQWpDO0FBQ0E7O0FBRUQsVUFBTyxLQUFQO0FBQ0E7O0FBRUQ7Ozs7O0FBS1l0QixXLEVBQVc7QUFDdEI7Ozs7Ozs7Ozs7O0FBV0EsT0FBSUssU0FBUyxLQUFLZ0MsT0FBTCxFQUFiOztBQUVBLE9BQUksT0FBT3JDLFNBQVAsSUFBb0IsVUFBeEIsRUFBb0M7QUFDbkM7QUFDQyxxQkFBZ0JBLFNBQWhCO0FBQ0dLLHVCQUFrQkwsU0FEckI7QUFFRyxZQUFPQSxVQUFVQyxJQUFqQixJQUF5QixRQUF6QixJQUFxQyxLQUFLRixVQUFMLENBQWlCQyxVQUFVQyxJQUEzQixDQUh6Qzs7QUFLQTs7QUFFRCxPQUFJLE9BQU9ELFNBQVAsSUFBb0IsUUFBeEIsRUFBa0M7QUFDakMsUUFBSSxLQUFLd0QsTUFBTCxDQUFheEQsVUFBVTBCLFdBQVYsRUFBYixDQUFKLEVBQTZDO0FBQzVDLFlBQU8sSUFBUDtBQUNBOztBQUVELFFBQUlyQixXQUFXLElBQVgsSUFBbUIsT0FBT0EsTUFBUCxJQUFpQixXQUF4QyxFQUFxRDtBQUNwRCxZQUFPLEtBQVA7QUFDQTs7QUFFRCxRQUFJLE9BQU9BLE1BQVAsSUFBaUIsVUFBakIsSUFBK0JBLE9BQU9KLElBQVAsS0FBZ0JELFNBQW5ELEVBQThEO0FBQzdELFlBQU8sSUFBUDtBQUNBOztBQUVELE9BQUU7QUFDRDtBQUNDLFlBQU9LLE1BQVAsSUFBaUIsVUFBakI7QUFDR0EsWUFBT0osSUFBUCxLQUFnQkQsU0FGaEI7O0FBSUgsWUFBT0ssT0FBT0gsV0FBZCxJQUE2QixVQUE3QjtBQUNHRyxZQUFPSCxXQUFQLENBQW1CRCxJQUFuQixLQUE0QkQsU0FMaEM7QUFNRztBQUNGLGFBQU8sSUFBUDtBQUNBO0FBQ0QsS0FWRCxRQVVRSyxTQUFTLDhCQUF1QkEsTUFBdkIsQ0FWakI7O0FBWUE7Ozs7O0FBS0EsUUFBSSxLQUFLSCxXQUFMLENBQWlCRCxJQUFqQixJQUF5QkQsU0FBN0IsRUFBd0M7QUFDdkMsU0FBSUssVUFBUyxJQUFiOztBQUVBLFFBQUU7QUFDRDtBQUNDLGFBQU9BLE9BQVAsSUFBaUIsVUFBakI7QUFDR0EsY0FBT0osSUFBUCxLQUFnQkQsU0FGaEI7O0FBSUgsYUFBT0ssUUFBT0gsV0FBZCxJQUE2QixVQUE3QjtBQUNHRyxjQUFPSCxXQUFQLENBQW1CRCxJQUFuQixLQUE0QkQsU0FMaEM7QUFNRztBQUNGLGNBQU8sSUFBUDtBQUNBO0FBQ0QsTUFWRCxRQVVRSyxVQUFTLDhCQUF1QkEsT0FBdkIsQ0FWakI7QUFXQTs7QUFFRCxXQUFPLEtBQVA7QUFDQTs7QUFFRCxVQUFPLEtBQVA7QUFDQTs7QUFFRDs7Ozs7O0FBTVk7QUFDWCxPQUFHO0FBQ0YsUUFBSSxLQUFLaUQsT0FBTCxNQUFtQixRQUF2QixFQUFpQztBQUNoQyxZQUFPLHlCQUFnQixLQUFLakIsT0FBTCxFQUFoQixDQUFQO0FBQ0E7O0FBRUQsV0FBT3pDLGVBQWUsS0FBS3lDLE9BQUwsRUFBdEI7O0FBRUEsSUFQRCxDQU9DLE9BQU9qQyxLQUFQLEVBQWM7QUFDZCxRQUFHO0FBQ0YsWUFBTyxLQUFLaUMsT0FBTCxHQUFnQmMsUUFBaEIsRUFBUDs7QUFFQSxLQUhELENBR0MsT0FBTy9DLEtBQVAsRUFBYztBQUNkLFlBQU8sS0FBSytDLFFBQUwsRUFBUDtBQUNBO0FBQ0Q7QUFDRDs7QUFFRDs7Ozs7QUFLYXZDLE0sRUFBTTRCLE0sRUFBUXhDLFMsRUFBVztBQUNyQzs7Ozs7Ozs7OztBQVVBLE9BQUl5RCxZQUFZNUQsS0FBS3VDLFdBQXJCOztBQUVBO0FBQ0MsVUFBTyxLQUFLbEMsV0FBWixJQUEyQixVQUEzQjtBQUNHLFVBQU8sS0FBS0EsV0FBTCxDQUFpQmtDLFdBQXhCLElBQXVDLFVBRDFDO0FBRUcsUUFBS2xDLFdBQUwsQ0FBaUJrQyxXQUFqQixDQUE2Qm5DLElBQTdCLEtBQXNDLGFBSDFDO0FBSUM7QUFDQXdELGdCQUFZLEtBQUt2RCxXQUFMLENBQWlCa0MsV0FBN0I7QUFDQTs7QUFFRCxPQUFJN0IsVUFBVUMsTUFBVixJQUFvQixDQUF4QixFQUEyQjtBQUMxQixXQUFPaUQsVUFBVyxLQUFLcEIsT0FBTCxFQUFYLEVBQTRCOUIsVUFBVyxDQUFYLENBQTVCLEVBQTRDQSxVQUFXLENBQVgsQ0FBNUMsQ0FBUDs7QUFFQSxJQUhELE1BR0s7QUFDSixXQUFPa0QsVUFBVzdDLElBQVgsRUFBaUI0QixNQUFqQixFQUF5QnhDLFNBQXpCLENBQVA7QUFDQTtBQUNEOztBQUVEOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBbUJBOzs7Ozs7Ozs7Ozs7QUFZVzBELGEsRUFBYTtBQUN2Qjs7Ozs7Ozs7QUFRQSxPQUFJaEIsUUFBUTdDLEtBQUs2RCxXQUFqQjs7QUFFQSxPQUFJLE9BQU9BLFdBQVAsSUFBc0IsVUFBMUIsRUFBc0M7QUFDckNBLGtCQUFjaEIsS0FBZDtBQUNBOztBQUVELE9BQUc7QUFDRixXQUFPLEtBQUtNLEdBQUwsQ0FBVVUsWUFBYSxJQUFiLENBQVYsQ0FBUDs7QUFFQSxJQUhELENBR0MsT0FBT3RELEtBQVAsRUFBYztBQUNkLFdBQU8sS0FBSzRDLEdBQUwsQ0FBVU4sTUFBTyxJQUFQLENBQVYsQ0FBUDtBQUNBO0FBQ0Q7O0FBRUQ7Ozs7Ozs7OztBQVNTckMsUSxFQUFRO0FBQ2hCOzs7Ozs7OztBQVFBLE9BQUlBLGtCQUFrQlIsSUFBdEIsRUFBNEI7QUFDM0IsV0FBTyxLQUFLd0MsT0FBTCxPQUFvQmhDLE9BQU9nQyxPQUFQLEVBQTNCO0FBQ0E7O0FBRUQsVUFBTyxLQUFLQSxPQUFMLE9BQW9CaEMsTUFBM0I7QUFDQTs7QUFFRDs7Ozs7QUFLYztBQUNiO0FBQ0MsU0FBTXRCLFNBQU4sTUFBc0JBLFNBQXRCO0FBQ0csU0FBSzRFLFFBQUwsRUFGSjs7QUFJQSxHOztBQUVVO0FBQ1Y7QUFDQyxTQUFNM0UsTUFBTixNQUFtQkEsTUFBbkI7QUFDR1EsZ0JBQVlxQixJQUFaLENBQWtCLEtBQUtDLFNBQUwsRUFBbEIsQ0FGSjs7QUFJQTs7QUFFRDs7Ozs7QUFLUTtBQUNQLFVBQU8sQ0FBQyxLQUFLOEMsUUFBTCxFQUFSO0FBQ0EsRzs7QUFFU3hELE8sRUFBTztBQUNoQixPQUFJQSxpQkFBaUJPLEtBQXJCLEVBQTRCO0FBQzNCLFNBQUtrRCxTQUFMLENBQWdCekQsS0FBaEI7QUFDQTs7QUFFRCxVQUFPLElBQVA7QUFDQSxHOztBQUVVQSxPLEVBQU87QUFDakIsT0FBSUEsaUJBQWlCTyxLQUFyQixFQUE0QjtBQUMzQixTQUFNbkMsS0FBTixFQUFja0MsSUFBZCxDQUFvQk4sS0FBcEI7QUFDQTs7QUFFRCxVQUFPLElBQVA7QUFDQSxHOztBQUVVO0FBQ1YsVUFBTyxLQUFNNUIsS0FBTixFQUFjc0YsT0FBZCxHQUEwQixDQUExQixDQUFQO0FBQ0EsRzs7QUFFVTtBQUNWLFVBQU8sS0FBTXRGLEtBQU4sRUFBY2dDLE1BQWQsR0FBdUIsQ0FBOUI7QUFDQSxHOztBQUVjdUQsVyxFQUFXO0FBQ3pCOzs7Ozs7OztBQVFBLE9BQUlBLHFCQUFxQkMsS0FBekIsRUFBZ0M7QUFDL0IsUUFBSUMsT0FBTyxLQUFNekYsS0FBTixFQUFjc0YsT0FBZCxFQUFYO0FBQ0EsUUFBSS9DLFFBQVFrRCxLQUFLekQsTUFBakI7QUFDQSxXQUFPTyxPQUFQLEdBQWlCZ0QsVUFBVXJELElBQVYsQ0FBZ0J1RCxLQUFNbEQsS0FBTixDQUFoQixFQUFqQjtBQUNBOztBQUVELFVBQU8sSUFBUDtBQUNBOztBQUVEOzs7OztBQUtPVCxPLEVBQU87QUFDYjs7Ozs7Ozs7QUFRQSxVQUFPVCxLQUFLc0IsTUFBTCxDQUFhLEtBQUtqQixXQUFsQixFQUErQixLQUFLbUMsT0FBTCxFQUEvQixFQUFnRC9CLEtBQWhELENBQVA7QUFDQTs7QUFFRDs7Ozs7QUFLUUEsTyxFQUFPO0FBQ2Q7Ozs7Ozs7O0FBUUEsVUFBT1QsS0FBS3NCLE1BQUwsQ0FBYXRCLElBQWIsRUFBbUIsS0FBS3dDLE9BQUwsRUFBbkIsRUFBb0MvQixLQUFwQyxDQUFQO0FBQ0E7O0FBRUQ7Ozs7OztBQU1TO0FBQ1IsT0FBSUEsUUFBUSxFQUFaOztBQUVBLE9BQUksS0FBSzRELFdBQUwsRUFBSixFQUF5QjtBQUN4QjVELFVBQU1JLElBQU4sQ0FBWTNCLFNBQVo7QUFDQTs7QUFFRCxPQUFJLEtBQUs0RSxRQUFMLEVBQUosRUFBc0I7QUFDckIsU0FBS1EsYUFBTCxDQUFvQjdELEtBQXBCO0FBQ0E7O0FBRUQsVUFBTyxLQUFLOEQsTUFBTCxDQUFhOUQsS0FBYixDQUFQO0FBQ0EsRzs7QUFFUztBQUNULFVBQU8sS0FBTS9CLElBQU4sQ0FBUDtBQUNBLEc7O0FBRVM7QUFDVCxVQUFPLEtBQU1GLElBQU4sQ0FBUDtBQUNBLEcsc0RBL2Y0QixDQUM1QixPQUFPLEtBQUtrRixPQUFMLEVBQVAsQ0FDQSxDLENBRUQ7Ozs7Ozs7OzsrRkFZTTlFLE0sc0JBQVcsQ0FDaEIsT0FBTyxzQkFBZSxFQUNyQixRQUFRLEtBQUs2RSxPQUFMLEVBRGEsRUFFckIsUUFBUSxLQUFLQyxPQUFMLEVBRmEsRUFHckIsU0FBUyxLQUFLYyxTQUFMLEVBSFksRUFJckIsVUFBVTVFLFlBSlcsRUFBZixDQUFQLENBTUEsQyxXQUVLZixPLHNCQUFZLENBQ2pCLE9BQU8sSUFBUCxDQUNBLEMsV0FFS0MsTSxzQkFBVyxDQUNoQixPQUFPMkYsT0FBT0MsU0FBUCxDQUFpQnBCLFFBQWpCLENBQTBCcUIsSUFBMUIsQ0FBZ0MsS0FBS25DLE9BQUwsRUFBaEMsQ0FBUCxDQUNBLEMsV0FFS3pELE0sc0JBQVcsQ0FDaEIsT0FBT2lELFFBQVAsQ0FDQSxDLENBRUQ7Ozs7OzZkQU9NaEQsSyxzQkFBVSxDQUNmLE9BQU8sS0FBTVAsTUFBTixDQUFQLENBQ0EsQyx3REFxUW1CbUcsSSxFQUFNLENBQ3pCOzs7Ozs7K2tCQVFBLElBQUlsRCxRQUFRbkQsTUFBT3FHLEtBQUszRCxTQUFMLEVBQVAsRUFBMkI0RCxNQUEzQixFQUFaLENBRUEsWUFBVy9FLHdCQUF3QjZCLE9BQXhCLENBQWlDLE9BQWpDLEVBQTBDaUQsS0FBS25CLE9BQUwsRUFBMUMsQ0FBWCxHQUEyRS9CLEtBQTNFLENBQ0EsQyxxQkFtTUZyRCxPQUFRLE1BQVIsRUFBZ0JHLElBQWhCLEVBQXNCd0IsSUFBdEIsRUFDQTNCLE9BQVEsUUFBUixFQUFrQkksTUFBbEIsRUFBMEJ1QixJQUExQixFQUNBM0IsT0FBUSxNQUFSLEVBQWdCSyxJQUFoQixFQUFzQnNCLElBQXRCLEVBRUEzQixPQUFRLFFBQVIsRUFBa0JPLE1BQWxCLEVBQTBCb0IsSUFBMUIsRUFDQTNCLE9BQVEsU0FBUixFQUFtQlEsT0FBbkIsRUFBNEJtQixJQUE1QixFQUNBM0IsT0FBUSxRQUFSLEVBQWtCUyxNQUFsQixFQUEwQmtCLElBQTFCLEVBQ0EzQixPQUFRLFFBQVIsRUFBa0JVLE1BQWxCLEVBQTBCaUIsSUFBMUIsRUFDQTNCLE9BQVEsT0FBUixFQUFpQlcsS0FBakIsRUFBd0JnQixJQUF4QixFQUVBM0IsT0FBUSxTQUFSLEVBQW1CWSxPQUFuQixFQUE0QmUsSUFBNUIsRUFDQTNCLE9BQVEsV0FBUixFQUFxQmEsU0FBckIsRUFBZ0NjLElBQWhDLEVBQ0EzQixPQUFRLFFBQVIsRUFBa0JjLE1BQWxCLEVBQTBCYSxJQUExQixFQUVBM0IsT0FBUSxhQUFSLEVBQXVCc0IsV0FBdkIsRUFBb0NLLElBQXBDLEVBRUEzQixPQUFRLGNBQVIsRUFBd0J1QixZQUF4QixFQUFzQ0ksSUFBdEM7QUFFQThFLE9BQU9DLE9BQVAsR0FBaUIvRSxJQUFqQiIsImZpbGUiOiJtZXRhLnN1cHBvcnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJcInVzZSBzdHJpY3RcIjtcblxuLyo7XG5cdEBzdWJtb2R1bGUtbGljZW5zZTpcblx0XHRUaGUgTUlUIExpY2Vuc2UgKE1JVClcblx0XHRAbWl0LWxpY2Vuc2VcblxuXHRcdENvcHlyaWdodCAoQGMpIDIwMTcgUmljaGV2ZSBTaW9kaW5hIEJlYmVkb3Jcblx0XHRAZW1haWw6IHJpY2hldmUuYmViZWRvckBnbWFpbC5jb21cblxuXHRcdFBlcm1pc3Npb24gaXMgaGVyZWJ5IGdyYW50ZWQsIGZyZWUgb2YgY2hhcmdlLCB0byBhbnkgcGVyc29uIG9idGFpbmluZyBhIGNvcHlcblx0XHRvZiB0aGlzIHNvZnR3YXJlIGFuZCBhc3NvY2lhdGVkIGRvY3VtZW50YXRpb24gZmlsZXMgKHRoZSBcIlNvZnR3YXJlXCIpLCB0byBkZWFsXG5cdFx0aW4gdGhlIFNvZnR3YXJlIHdpdGhvdXQgcmVzdHJpY3Rpb24sIGluY2x1ZGluZyB3aXRob3V0IGxpbWl0YXRpb24gdGhlIHJpZ2h0c1xuXHRcdHRvIHVzZSwgY29weSwgbW9kaWZ5LCBtZXJnZSwgcHVibGlzaCwgZGlzdHJpYnV0ZSwgc3VibGljZW5zZSwgYW5kL29yIHNlbGxcblx0XHRjb3BpZXMgb2YgdGhlIFNvZnR3YXJlLCBhbmQgdG8gcGVybWl0IHBlcnNvbnMgdG8gd2hvbSB0aGUgU29mdHdhcmUgaXNcblx0XHRmdXJuaXNoZWQgdG8gZG8gc28sIHN1YmplY3QgdG8gdGhlIGZvbGxvd2luZyBjb25kaXRpb25zOlxuXG5cdFx0VGhlIGFib3ZlIGNvcHlyaWdodCBub3RpY2UgYW5kIHRoaXMgcGVybWlzc2lvbiBub3RpY2Ugc2hhbGwgYmUgaW5jbHVkZWQgaW4gYWxsXG5cdFx0Y29waWVzIG9yIHN1YnN0YW50aWFsIHBvcnRpb25zIG9mIHRoZSBTb2Z0d2FyZS5cblxuXHRcdFRIRSBTT0ZUV0FSRSBJUyBQUk9WSURFRCBcIkFTIElTXCIsIFdJVEhPVVQgV0FSUkFOVFkgT0YgQU5ZIEtJTkQsIEVYUFJFU1MgT1Jcblx0XHRJTVBMSUVELCBJTkNMVURJTkcgQlVUIE5PVCBMSU1JVEVEIFRPIFRIRSBXQVJSQU5USUVTIE9GIE1FUkNIQU5UQUJJTElUWSxcblx0XHRGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRSBBTkQgTk9OSU5GUklOR0VNRU5ULiBJTiBOTyBFVkVOVCBTSEFMTCBUSEVcblx0XHRBVVRIT1JTIE9SIENPUFlSSUdIVCBIT0xERVJTIEJFIExJQUJMRSBGT1IgQU5ZIENMQUlNLCBEQU1BR0VTIE9SIE9USEVSXG5cdFx0TElBQklMSVRZLCBXSEVUSEVSIElOIEFOIEFDVElPTiBPRiBDT05UUkFDVCwgVE9SVCBPUiBPVEhFUldJU0UsIEFSSVNJTkcgRlJPTSxcblx0XHRPVVQgT0YgT1IgSU4gQ09OTkVDVElPTiBXSVRIIFRIRSBTT0ZUV0FSRSBPUiBUSEUgVVNFIE9SIE9USEVSIERFQUxJTkdTIElOIFRIRVxuXHRcdFNPRlRXQVJFLlxuXHRAZW5kLXN1Ym1vZHVsZS1saWNlbnNlXG5cblx0QHN1Ym1vZHVsZS1jb25maWd1cmF0aW9uOlxuXHRcdHtcblx0XHRcdFwicGFja2FnZVwiOiBcImVobVwiLFxuXHRcdFx0XCJwYXRoXCI6IFwiZWhtL21ldGEubW9kdWxlLmpzXCIsXG5cdFx0XHRcImZpbGVcIjogXCJtZXRhLm1vZHVsZS5qc1wiLFxuXHRcdFx0XCJtb2R1bGVcIjogXCJlaG1cIixcblx0XHRcdFwiYXV0aG9yXCI6IFwiUmljaGV2ZSBTLiBCZWJlZG9yXCIsXG5cdFx0XHRcImVNYWlsXCI6IFwicmljaGV2ZS5iZWJlZG9yQGdtYWlsLmNvbVwiLFxuXHRcdFx0XCJyZXBvc2l0b3J5XCI6IFwiaHR0cHM6Ly9naXRodWIuY29tL3ZvbGtvdmFzeXN0ZW1zL2VobS5naXRcIixcblx0XHRcdFwidGVzdFwiOiBcImVobS10ZXN0LmpzXCIsXG5cdFx0XHRcImdsb2JhbFwiOiBmYWxzZSxcblx0XHRcdFwiaW50ZXJuYWxcIjogdHJ1ZSxcblx0XHRcdFwiY2xhc3NcIjogdHJ1ZVxuXHRcdH1cblx0QGVuZC1zdWJtb2R1bGUtY29uZmlndXJhdGlvblxuXG5cdEBzdWJtb2R1bGUtZG9jdW1lbnRhdGlvbjpcblx0XHRNZXRhIGNsYXNzIGNvbnN0cnVjdC5cblx0QGVuZC1zdWJtb2R1bGUtZG9jdW1lbnRhdGlvblxuXG5cdEBpbmNsdWRlOlxuXHRcdHtcblx0XHRcdFwiaGFyZGVuXCI6IFwiaGFyZGVuXCIsXG5cdFx0XHRcInN4dHk0XCI6IFwic3h0eTRcIlxuXHRcdH1cblx0QGVuZC1pbmNsdWRlXG4qL1xuXG5jb25zdCBoYXJkZW4gPSByZXF1aXJlKCBcImhhcmRlblwiICk7XG5jb25zdCBzeHR5NCA9IHJlcXVpcmUoIFwic3h0eTRcIiApO1xuXG5jb25zdCBOQU1FID0gU3ltYm9sKCBcIm5hbWVcIiApO1xuY29uc3QgRU5USVRZID0gU3ltYm9sKCBcImVudGl0eVwiICk7XG5jb25zdCBUWVBFID0gU3ltYm9sKCBcInR5cGVcIiApO1xuXG5jb25zdCBFUlJPUiA9IFN5bWJvbCggXCJlcnJvclwiICk7XG5cbmNvbnN0IE9CSkVDVCA9IFN5bWJvbCggXCJvYmplY3RcIiApO1xuY29uc3QgQk9PTEVBTiA9IFN5bWJvbCggXCJib29sZWFuXCIgKTtcbmNvbnN0IFNUUklORyA9IFN5bWJvbCggXCJzdHJpbmdcIiApO1xuY29uc3QgTlVNQkVSID0gU3ltYm9sKCBcIm51bWJlclwiICk7XG5jb25zdCBWQUxVRSA9IFN5bWJvbCggXCJ2YWx1ZVwiICk7XG5cbmNvbnN0IEdBUkJBR0UgPSBTeW1ib2woIFwiZ2FyYmFnZVwiICk7XG5jb25zdCBDT1JSVVBURUQgPSBTeW1ib2woIFwiY29ycnVwdGVkXCIgKTtcbmNvbnN0IFRBR0dFRCA9IFN5bWJvbCggXCJ0YWdnZWRcIiApO1xuXG5jb25zdCBBUkdVTUVOVFNfUEFUVEVSTiA9IC9eXFxbb2JqZWN0IEFyZ3VtZW50c1xcXSQvO1xuY29uc3QgQ0xBU1NfTkFNRV9QQVRURVJOID0gL15bQS1aXVthLXpBLVowLTldKyQvO1xuY29uc3QgREFUQV9VUkxfUEFUVEVSTiA9IC9eZGF0YVxcOlthLXpdW1xcLWEtejAtOV0rXFwvKFthLXpdW1xcLWEtejAtOV0rKSg/OlxcO2Jhc2U2NCk/XFwsLztcbmNvbnN0IEVWQUxfVVNBR0VfUEFUVEVSTiA9IC9cXGJldmFsXFwoLio/XFwpfFxcYmV2YWxcXGIvZ207XG5jb25zdCBGVU5DVElPTl9DTEFTU19VU0FHRV9QQVRURVJOID0gL1xcYkZ1bmN0aW9uXFwoLio/XFwpfFxcYkZ1bmN0aW9uXFxiL2dtO1xuY29uc3QgRkxPQVRfTlVNQkVSX1BBVFRFUk4gPSAvXFwuLztcbmNvbnN0IFNZTUJPTF9QQVRURVJOID0gL15TeW1ib2xcXCgoLio/KVxcKSQvO1xuY29uc3QgVEFHX1BBVFRFUk4gPSAvXlxcWyhbYS16QS1aXVtcXC1hLXpBLVowLTldKylcXHMrW0EtWl1bYS16QS1aMC05XSsoPzpcXDooLis/KSk/XFxdJC87XG5cbmNvbnN0IERBVEFfVVJMX1RBRyA9IFwiZGF0YS11cmwtdGFnXCI7XG5jb25zdCBERUZBVUxUX0ZPUk1BVCA9IERBVEFfVVJMX1RBRztcbmNvbnN0IERFRkFVTFRfREFUQV9VUkxfUFJFRklYID0gXCJkYXRhOnRleHQvQHR5cGU7YmFzZTY0LFwiO1xuY29uc3QgRU1QVFlfU1RSSU5HID0gXCJcIjtcblxuY2xhc3MgTWV0YSB7XG5cdHN0YXRpYyBbIFN5bWJvbC5oYXNJbnN0YW5jZSBdKCBpbnN0YW5jZSApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwiaW5zdGFuY2U6cmVxdWlyZWRcIjogXCIqXCJcblx0XHRcdFx0fVxuXHRcdFx0QGVuZC1tZXRhLWNvbmZpZ3VyYXRpb25cblx0XHQqL1xuXG5cdFx0cmV0dXJuIHRoaXMuaW5zdGFuY2VPZiggaW5zdGFuY2UsIHRoaXMgKTtcblx0fVxuXG5cdHN0YXRpYyBpbnN0YW5jZU9mKCBpbnN0YW5jZSwgYmx1ZXByaW50ICl7XG5cdFx0Lyo7XG5cdFx0XHRAbWV0YS1jb25maWd1cmF0aW9uOlxuXHRcdFx0XHR7XG5cdFx0XHRcdFx0XCJpbnN0YW5jZTpyZXF1aXJlZFwiOiBcIipcIixcblx0XHRcdFx0XHRcImJsdWVwcmludFwiOiBcImZ1bmN0aW9uXCJcblx0XHRcdFx0fVxuXHRcdFx0QGVuZC1tZXRhLWNvbmZpZ3VyYXRpb25cblx0XHQqL1xuXG5cdFx0aWYoIChcblx0XHRcdHR5cGVvZiBpbnN0YW5jZSA9PSBcImZ1bmN0aW9uXCJcblx0XHRcdCYmIHR5cGVvZiBibHVlcHJpbnQgPT0gXCJmdW5jdGlvblwiXG5cdFx0XHQmJiBpbnN0YW5jZS5uYW1lID09PSBibHVlcHJpbnQubmFtZVxuXHRcdCkgfHwgKFxuXHRcdFx0dHlwZW9mIGluc3RhbmNlID09IFwib2JqZWN0XCJcblx0XHRcdCYmIGluc3RhbmNlICE9IG51bGxcblx0XHRcdCYmIHR5cGVvZiBibHVlcHJpbnQgPT0gXCJmdW5jdGlvblwiXG5cdFx0XHQmJiBpbnN0YW5jZS5jb25zdHJ1Y3Rvci5uYW1lID09PSBibHVlcHJpbnQubmFtZVxuXHRcdCkgKXtcblx0XHRcdHJldHVybiB0cnVlO1xuXHRcdH1cblxuXHRcdC8qO1xuXHRcdFx0QG5vdGU6XG5cdFx0XHRcdFBvc3NpYmlsaXR5IG9mIGluc3RhbmNlIGJlaW5nIGdhcmJhZ2UuXG5cblx0XHRcdFx0RG8gbm90IHJlbW92ZSB0aGlzLiBUaGlzIGlzIGEgc3BlY2lhbCBwcm9jZWR1cmUuXG5cdFx0XHRAZW5kLW5vdGVcblx0XHQqL1xuXHRcdGlmKCBpbnN0YW5jZSA9PT0gR0FSQkFHRSApe1xuXHRcdFx0cmV0dXJuIGZhbHNlO1xuXHRcdH1cblxuXHRcdGlmKCB0eXBlb2YgYmx1ZXByaW50ICE9IFwiZnVuY3Rpb25cIiApe1xuXHRcdFx0Ymx1ZXByaW50ID0gdGhpcztcblx0XHR9XG5cblx0XHR0cnl7XG5cdFx0XHRyZXR1cm4gKCBuZXcgYmx1ZXByaW50KCBHQVJCQUdFICkgKVxuXHRcdFx0XHQuX19pbml0aWFsaXplX18oIGluc3RhbmNlLCBibHVlcHJpbnQubmFtZSApXG5cdFx0XHRcdC5pbnN0YW5jZU9mKCBibHVlcHJpbnQubmFtZSApO1xuXG5cdFx0fWNhdGNoKCBlcnJvciApe1xuXHRcdFx0cmV0dXJuIGZhbHNlO1xuXHRcdH1cblx0fVxuXG5cdHN0YXRpYyBjcmVhdGUoIGJsdWVwcmludCwgZW50aXR5LCBzdGF0ZSApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwiYmx1ZXByaW50OnJlcXVpcmVkXCI6IFwiZnVuY3Rpb25cIixcblx0XHRcdFx0XHRcImVudGl0eVwiOiBcIipcIixcblx0XHRcdFx0XHRcInN0YXRlXCI6IEFycmF5XG5cdFx0XHRcdH1cblx0XHRcdEBlbmQtbWV0YS1jb25maWd1cmF0aW9uXG5cdFx0Ki9cblxuXHRcdGlmKCBhcmd1bWVudHMubGVuZ3RoID09IDAgKXtcblx0XHRcdGJsdWVwcmludCA9IHRoaXM7XG5cdFx0XHRlbnRpdHkgPSB1bmRlZmluZWQ7XG5cdFx0XHRzdGF0ZSA9IFsgXTtcblx0XHR9XG5cblx0XHRpZiggYXJndW1lbnRzLmxlbmd0aCA9PSAxICl7XG5cdFx0XHRibHVlcHJpbnQgPSB0aGlzO1xuXHRcdFx0ZW50aXR5ID0gYXJndW1lbnRzWyAwIF07XG5cdFx0XHRzdGF0ZSA9IFsgXTtcblx0XHR9XG5cblx0XHRpZiggYXJndW1lbnRzLmxlbmd0aCA9PSAyICl7XG5cdFx0XHRibHVlcHJpbnQgPSBhcmd1bWVudHNbIDAgXTtcblx0XHRcdGVudGl0eSA9IGFyZ3VtZW50c1sgMSBdO1xuXHRcdFx0c3RhdGUgPSBbIF07XG5cdFx0fVxuXG5cdFx0aWYoIHR5cGVvZiBibHVlcHJpbnQgIT0gXCJmdW5jdGlvblwiICl7XG5cdFx0XHRibHVlcHJpbnQgPSB0aGlzO1xuXHRcdH1cblxuXHRcdGlmKCB0eXBlb2Ygc3RhdGUgPT0gXCJvYmplY3RcIiApe1xuXHRcdFx0c3RhdGUgPSBBcnJheS5mcm9tKCBzdGF0ZSApO1xuXG5cdFx0fWVsc2V7XG5cdFx0XHRzdGF0ZSA9IFsgXTtcblx0XHR9XG5cblx0XHQvKjtcblx0XHRcdEBub3RlOlxuXHRcdFx0XHRJZiB3ZSBhcmUgZ29pbmcgdG8gdGhyb3cgYW4gZXJyb3IgaGVyZSwgcG9zc2liaWxpdHkgb2YgaW5maW5pdGUgcmVjdXJzaW9uLlxuXG5cdFx0XHRcdFdlIGNhbiBwdXNoIGFuIGVycm9yIGluc3RlYWQuXG5cdFx0XHRAZW5kLW5vdGVcblx0XHQqL1xuXHRcdGlmKCAhKCBibHVlcHJpbnQgaW5zdGFuY2VvZiB0aGlzICkgKXtcblx0XHRcdHN0YXRlLnB1c2goIG5ldyBFcnJvciggYGluY29tcGF0aWJsZSBibHVlcHJpbnQsICR7IGJsdWVwcmludC5uYW1lIH1gICkgKTtcblxuXHRcdFx0Ymx1ZXByaW50ID0gdGhpcztcblx0XHR9XG5cblx0XHR0cnl7XG5cdFx0XHRsZXQgZGF0YSA9IG5ldyBibHVlcHJpbnQoIGVudGl0eSApO1xuXG5cdFx0XHRpZiggVEFHX1BBVFRFUk4udGVzdCggZGF0YS5zdHJpbmdpZnkoICkgKSApe1xuXHRcdFx0XHRzdGF0ZS5wdXNoKCBUQUdHRUQgKTtcblx0XHRcdH1cblxuXHRcdFx0bGV0IGluZGV4ID0gc3RhdGUubGVuZ3RoO1xuXHRcdFx0d2hpbGUoIGluZGV4LS0gKXtcblx0XHRcdFx0bGV0IHN0YXR1cyA9IHN0YXRlWyBpbmRleCBdO1xuXG5cdFx0XHRcdGlmKCBzdGF0dXMgaW5zdGFuY2VvZiBFcnJvciApe1xuXHRcdFx0XHRcdGRhdGEuc2V0RXJyb3IoIHN0YXR1cyApO1xuXG5cdFx0XHRcdH1lbHNle1xuXHRcdFx0XHRcdGhhcmRlbiggc3RhdHVzLCBzdGF0dXMsIGRhdGEgKTtcblx0XHRcdFx0fVxuXHRcdFx0fVxuXG5cdFx0XHRyZXR1cm4gT2JqZWN0LmZyZWV6ZSggZGF0YSApO1xuXG5cdFx0fWNhdGNoKCBlcnJvciApe1xuXHRcdFx0c3RhdGUucHVzaCggbmV3IEVycm9yKCBgY2Fubm90IHdyYXAgZGF0YSwgJHsgZXJyb3Iuc3RhY2sgfWAgKSApO1xuXG5cdFx0XHRyZXR1cm4gTWV0YS5jcmVhdGUoIHRoaXMsIGVudGl0eSwgc3RhdGUgKTtcblx0XHR9XG5cdH1cblxuXHQvKjtcblx0XHRAc3RhdGljLW1ldGhvZC1kb2N1bWVudGF0aW9uOlxuXHRcdFx0RGVmYXVsdCBnZW5lcmljIGRlc2VyaWFsaXphdGlvbiBwYXJzZXIuXG5cdFx0QGVuZC1zdGF0aWMtbWV0aG9kLWRvY3VtZW50YXRpb25cblx0Ki9cblx0c3RhdGljIHBhcnNlciggZGF0YSApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwiZGF0YTpyZXF1aXJlZFwiOiBcInN0cmluZ1wiXG5cdFx0XHRcdH1cblx0XHRcdEBlbmQtbWV0YS1jb25maWd1cmF0aW9uXG5cdFx0Ki9cblxuXHRcdGlmKCB0eXBlb2YgZGF0YSAhPSBcInN0cmluZ1wiICl7XG5cdFx0XHR0aHJvdyBuZXcgRXJyb3IoIGBjYW5ub3QgcGFyc2UgZGF0YSwgJHsgZGF0YSB9YCApO1xuXHRcdH1cblxuXHRcdHRyeXtcblx0XHRcdGxldCB0b2tlbiA9IGRhdGEubWF0Y2goIFRBR19QQVRURVJOICkgfHwgWyBdO1xuXHRcdFx0bGV0IHR5cGUgPSB0b2tlblsgMSBdIHx8IFwidW5kZWZpbmVkXCI7XG5cdFx0XHRsZXQgdmFsdWUgPSB0b2tlblsgMiBdIHx8IEVNUFRZX1NUUklORztcblxuXHRcdFx0aWYoIHZhbHVlID09IEVNUFRZX1NUUklORyApe1xuXHRcdFx0XHR2YWx1ZSA9IGRhdGE7XG5cdFx0XHR9XG5cblx0XHRcdC8qO1xuXHRcdFx0XHRAbm90ZTpcblx0XHRcdFx0XHRJZiB0aGUgdmFsdWUgaXMgYSBkYXRhIHVybCBmb3JtYXQsIHRyeSB0byBkZWNvZGUgaXQuXG5cblx0XHRcdFx0XHRFbnN1cmUgdGhhdCB3ZSBoYXZlIHRoZSBjb3JyZWN0IHR5cGUuXG5cdFx0XHRcdEBlbmQtbm90ZVxuXHRcdFx0Ki9cblx0XHRcdGlmKCBEQVRBX1VSTF9QQVRURVJOLnRlc3QoIHZhbHVlICkgKXtcblx0XHRcdFx0dHlwZSA9ICggdmFsdWUubWF0Y2goIERBVEFfVVJMX1BBVFRFUk4gKSB8fCBbIF0gKVsgMSBdIHx8IHR5cGU7XG5cdFx0XHRcdHZhbHVlID0gdmFsdWUucmVwbGFjZSggREVGQVVMVF9EQVRBX1VSTF9QUkVGSVgucmVwbGFjZSggXCJAdHlwZVwiLCB0eXBlICksIEVNUFRZX1NUUklORyApO1xuXHRcdFx0XHR2YWx1ZSA9IHN4dHk0KCB2YWx1ZSApLmRlY29kZSggKTtcblx0XHRcdH1cblxuXHRcdFx0c3dpdGNoKCB0eXBlICl7XG5cdFx0XHRcdGNhc2UgXCJib29sZWFuXCI6XG5cdFx0XHRcdFx0aWYoIHZhbHVlLnRvTG93ZXJDYXNlKCApID09IFwidHJ1ZVwiICl7XG5cdFx0XHRcdFx0XHRyZXR1cm4gdHJ1ZTtcblx0XHRcdFx0XHR9XG5cblx0XHRcdFx0XHRpZiggdmFsdWUudG9Mb3dlckNhc2UoICkgPT0gXCJmYWxzZVwiICl7XG5cdFx0XHRcdFx0XHRyZXR1cm4gZmFsc2U7XG5cdFx0XHRcdFx0fVxuXG5cdFx0XHRcdFx0dGhyb3cgbmV3IEVycm9yKCBgY2Fubm90IHBhcnNlIGJvb2xlYW4sICR7IHZhbHVlIH1gICk7XG5cblx0XHRcdFx0Y2FzZSBcImZ1bmN0aW9uXCI6XG5cdFx0XHRcdFx0dHJ5e1xuXHRcdFx0XHRcdFx0aWYoIEVWQUxfVVNBR0VfUEFUVEVSTi50ZXN0KCB2YWx1ZSApICl7XG5cdFx0XHRcdFx0XHRcdHRocm93IG5ldyBFcnJvciggXCJjYW5ub3QgcGFyc2UgZnVuY3Rpb24sIGNvbnRhaW5zIGV2YWwsIHBvdGVudGlhbCBzZWN1cml0eSBpc3N1ZVwiICk7XG5cdFx0XHRcdFx0XHR9XG5cblx0XHRcdFx0XHRcdGlmKCBGVU5DVElPTl9DTEFTU19VU0FHRV9QQVRURVJOLnRlc3QoIHZhbHVlICkgKXtcblx0XHRcdFx0XHRcdFx0dGhyb3cgbmV3IEVycm9yKCBcImNhbm5vdCBwYXJzZSBmdW5jdGlvbiwgY29udGFpbnMgZnVuY3Rpb24gY2xhc3MsIHBvdGVudGlhbCBzZWN1cml0eSBpc3N1ZVwiICk7XG5cdFx0XHRcdFx0XHR9XG5cblx0XHRcdFx0XHRcdGxldCBtZXRob2QgPSAoIG5ldyBGdW5jdGlvbiggXCJyZXR1cm4gXCIgKyB2YWx1ZSApICkoICk7XG5cblx0XHRcdFx0XHRcdGlmKCB0eXBlb2YgbWV0aG9kICE9IFwiZnVuY3Rpb25cIiApe1xuXHRcdFx0XHRcdFx0XHRyZXR1cm4gZnVuY3Rpb24oICl7IHRocm93IG5ldyBFcnJvciggYG5vIG9wZXJhdGlvbiBkb25lLCAkeyB2YWx1ZSB9YCApOyB9O1xuXHRcdFx0XHRcdFx0fVxuXG5cdFx0XHRcdFx0XHRyZXR1cm4gbWV0aG9kO1xuXG5cdFx0XHRcdFx0fWNhdGNoKCBlcnJvciApe1xuXHRcdFx0XHRcdFx0dGhyb3cgbmV3IEVycm9yKCBgY2Fubm90IHBhcnNlIGZ1bmN0aW9uLCAkeyB2YWx1ZSB9LCAkeyBlcnJvci5zdGFjayB9YCApO1xuXHRcdFx0XHRcdH1cblxuXHRcdFx0XHRjYXNlIFwibnVtYmVyXCI6XG5cdFx0XHRcdFx0dHJ5e1xuXHRcdFx0XHRcdFx0aWYoIHZhbHVlID09IFwiSW5maW5pdHlcIiApe1xuXHRcdFx0XHRcdFx0XHRyZXR1cm4gSW5maW5pdHk7XG5cdFx0XHRcdFx0XHR9XG5cblx0XHRcdFx0XHRcdGlmKCB2YWx1ZSA9PSBcIk5hTlwiICl7XG5cdFx0XHRcdFx0XHRcdHJldHVybiBOYU47XG5cdFx0XHRcdFx0XHR9XG5cblx0XHRcdFx0XHRcdGlmKCBGTE9BVF9OVU1CRVJfUEFUVEVSTi50ZXN0KCB2YWx1ZSApICl7XG5cdFx0XHRcdFx0XHRcdHJldHVybiBwYXJzZUZsb2F0KCB2YWx1ZSApO1xuXHRcdFx0XHRcdFx0fVxuXG5cdFx0XHRcdFx0XHRpZiggIUZMT0FUX05VTUJFUl9QQVRURVJOLnRlc3QoIHZhbHVlICkgKXtcblx0XHRcdFx0XHRcdFx0cmV0dXJuIHBhcnNlSW50KCB2YWx1ZSApO1xuXHRcdFx0XHRcdFx0fVxuXG5cdFx0XHRcdFx0XHR0aHJvdyBuZXcgRXJyb3IoIGBjYW5ub3QgcGFyc2UgbnVtYmVyLCAkeyB2YWx1ZSB9YCApO1xuXG5cdFx0XHRcdFx0fWNhdGNoKCBlcnJvciApe1xuXHRcdFx0XHRcdFx0dGhyb3cgbmV3IEVycm9yKCBgY2Fubm90IHBhcnNlIG51bWJlciwgJHsgdmFsdWUgfSwgJHsgZXJyb3Iuc3RhY2sgfWAgKTtcblx0XHRcdFx0XHR9XG5cblx0XHRcdFx0Y2FzZSBcIm9iamVjdFwiOlxuXHRcdFx0XHRcdGlmKCB2YWx1ZSA9PSBcIm51bGxcIiApe1xuXHRcdFx0XHRcdFx0cmV0dXJuIG51bGw7XG5cdFx0XHRcdFx0fVxuXG5cdFx0XHRcdFx0dHJ5e1xuXHRcdFx0XHRcdFx0dmFsdWUgPSBKU09OLnBhcnNlKCB2YWx1ZSApO1xuXG5cdFx0XHRcdFx0XHQvKjtcblx0XHRcdFx0XHRcdFx0VGhpcyBpcyB0aGUgc3BlY2lmaWNhdGlvbiBmb3IgdGhlIGJhc2ljXG5cdFx0XHRcdFx0XHRcdFx0bWV0YSBvYmplY3Qgc3RydWN0dXJlLlxuXHRcdFx0XHRcdFx0Ki9cblx0XHRcdFx0XHRcdGlmKFxuXHRcdFx0XHRcdFx0XHRcInR5cGVcIiBpbiB2YWx1ZSAmJiB0eXBlb2YgdmFsdWUudHlwZSA9PSBcInN0cmluZ1wiXG5cdFx0XHRcdFx0XHRcdCYmIFwibmFtZVwiIGluIHZhbHVlICYmIHR5cGVvZiB2YWx1ZS5uYW1lID09IFwic3RyaW5nXCJcblx0XHRcdFx0XHRcdFx0JiYgXCJ2YWx1ZVwiIGluIHZhbHVlICYmIHR5cGVvZiB2YWx1ZS52YWx1ZSA9PSBcInN0cmluZ1wiXG5cdFx0XHRcdFx0XHRcdCYmIFwiZm9ybWF0XCIgaW4gdmFsdWUgJiYgdHlwZW9mIHZhbHVlLmZvcm1hdCA9PSBcInN0cmluZ1wiXG5cdFx0XHRcdFx0XHRcdCYmIHZhbHVlLmZvcm1hdCA9PSBEQVRBX1VSTF9UQUdcblx0XHRcdFx0XHRcdFx0JiYgVEFHX1BBVFRFUk4udGVzdCggdmFsdWUudmFsdWUgKVxuXHRcdFx0XHRcdFx0KXtcblx0XHRcdFx0XHRcdFx0cmV0dXJuIE1ldGEuZGVzZXJpYWxpemUoIHZhbHVlLnZhbHVlICkudmFsdWVPZiggKTtcblx0XHRcdFx0XHRcdH1cblxuXHRcdFx0XHRcdFx0cmV0dXJuIHZhbHVlO1xuXG5cdFx0XHRcdFx0fWNhdGNoKCBlcnJvciApe1xuXHRcdFx0XHRcdFx0cmV0dXJuIG5ldyBFcnJvciggYGNhbm5vdCBwYXJzZSBvYmplY3QsICR7IHZhbHVlIH0sICR7IGVycm9yLnN0YWNrIH1gICk7XG5cdFx0XHRcdFx0fVxuXG5cdFx0XHRcdGNhc2UgXCJzdHJpbmdcIjpcblx0XHRcdFx0XHRyZXR1cm4gdmFsdWU7XG5cblx0XHRcdFx0Y2FzZSBcInN5bWJvbFwiOlxuXHRcdFx0XHRcdGxldCBzeW1ib2wgPSAoICggdmFsdWUubWF0Y2goIFNZTUJPTF9QQVRURVJOICkgfHwgWyBdIClbIDEgXSB8fCBFTVBUWV9TVFJJTkcgKS50cmltKCApO1xuXG5cdFx0XHRcdFx0aWYoIHN5bWJvbCA9PSBFTVBUWV9TVFJJTkcgKXtcblx0XHRcdFx0XHRcdHRocm93IG5ldyBFcnJvciggYGNhbm5vdCBwYXJzZSBzeW1ib2wsICR7IHZhbHVlIH1gICk7XG5cdFx0XHRcdFx0fVxuXG5cdFx0XHRcdFx0cmV0dXJuIFN5bWJvbCggc3ltYm9sICk7XG5cblx0XHRcdFx0Y2FzZSBcInVuZGVmaW5lZFwiOlxuXHRcdFx0XHRcdHJldHVybiB1bmRlZmluZWQ7XG5cdFx0XHR9XG5cblx0XHR9Y2F0Y2goIGVycm9yICl7XG5cdFx0XHR0aHJvdyBuZXcgRXJyb3IoIGBjYW5ub3QgcGFyc2UgZGF0YSwgJHsgZGF0YSB9LCAkeyBlcnJvci5zdGFjayB9YCApO1xuXHRcdH1cblxuXHRcdHRocm93IG5ldyBFcnJvciggYGNhbm5vdCBwYXJzZSBkYXRhLCAkeyBkYXRhIH1gICk7XG5cdH1cblxuXHQvKjtcblx0XHRAc3RhdGljLW1ldGhvZC1kb2N1bWVudGF0aW9uOlxuXHRcdFx0R2VuZXJpYyBtZXRhIGRhdGEgZGVzZXJpYWxpemF0aW9uLlxuXHRcdEBlbmQtc3RhdGljLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cdCovXG5cdHN0YXRpYyBkZXNlcmlhbGl6ZSggZGF0YSwgcGFyc2VyLCBibHVlcHJpbnQgKXtcblx0XHQvKjtcblx0XHRcdEBtZXRhLWNvbmZpZ3VyYXRpb246XG5cdFx0XHRcdHtcblx0XHRcdFx0XHRcImRhdGFcIjogXCIqXCIsXG5cdFx0XHRcdFx0XCJwYXJzZXJcIjogXCJmdW5jdGlvblwiLFxuXHRcdFx0XHRcdFwiYmx1ZXByaW50XCI6IFwiZnVuY3Rpb25cIlxuXHRcdFx0XHR9XG5cdFx0XHRAZW5kLW1ldGEtY29uZmlndXJhdGlvblxuXHRcdCovXG5cblx0XHR2YXIgWyBkYXRhLCBwYXJzZXIsIGRlZmVyLCBibHVlcHJpbnQgXSA9IE1ldGEuX19kZXNlcmlhbGl6ZURlZmVyX18oIGFyZ3VtZW50cywgdGhpcywgTWV0YS5wYXJzZXIgKTtcblxuXHRcdHRyeXtcblx0XHRcdHJldHVybiBNZXRhLmNyZWF0ZSggYmx1ZXByaW50LCBwYXJzZXIoIGRhdGEgKSApO1xuXG5cdFx0fWNhdGNoKCBlcnJvciApe1xuXHRcdFx0cmV0dXJuIE1ldGEuY3JlYXRlKCBibHVlcHJpbnQsIGRlZmVyKCBkYXRhICksIFsgQ09SUlVQVEVELCBlcnJvciBdICk7XG5cdFx0fVxuXHR9XG5cblx0c3RhdGljIF9fZGVzZXJpYWxpemVEZWZlcl9fKCBwYXJhbWV0ZXIsIGJsdWVwcmludCwgcGFyc2VyICl7XG5cdFx0Lyo7XG5cdFx0XHRAbWV0YS1jb25maWd1cmF0aW9uOlxuXHRcdFx0XHR7XG5cdFx0XHRcdFx0XCJwYXJhbWV0ZXI6cmVxdWlyZWRcIjogQXJndW1lbnRzLFxuXHRcdFx0XHRcdFwiYmx1ZXByaW50OnJlcXVpcmVkXCI6IFwiZnVuY3Rpb25cIixcblx0XHRcdFx0XHRcInBhcnNlcjpyZXF1aXJlZFwiOiBcImZ1bmN0aW9uXCJcblx0XHRcdFx0fVxuXHRcdFx0QGVuZC1tZXRhLWNvbmZpZ3VyYXRpb25cblx0XHQqL1xuXG5cdFx0aWYoICFBUkdVTUVOVFNfUEFUVEVSTi50ZXN0KCBwYXJhbWV0ZXIgKSApe1xuXHRcdFx0dGhyb3cgbmV3IEVycm9yKCBcImludmFsaWQgcGFyYW1ldGVyXCIgKTtcblx0XHR9XG5cblx0XHRpZiggdHlwZW9mIGJsdWVwcmludCAhPSBcImZ1bmN0aW9uXCIgKXtcblx0XHRcdHRocm93IG5ldyBFcnJvciggXCJpbnZhbGlkIGJsdWVwcmludFwiICk7XG5cdFx0fVxuXG5cdFx0aWYoIHR5cGVvZiBwYXJzZXIgIT0gXCJmdW5jdGlvblwiICl7XG5cdFx0XHR0aHJvdyBuZXcgRXJyb3IoIFwiaW52YWxpZCBwYXJzZXJcIiApO1xuXHRcdH1cblxuXHRcdGxldCBhcmd1bWVudCA9IHBhcmFtZXRlcjtcblxuXHRcdHRyeXtcblx0XHRcdHBhcmFtZXRlciA9IEFycmF5LmZyb20oIHBhcmFtZXRlciApO1xuXG5cdFx0fWNhdGNoKCBlcnJvciApe1xuXHRcdFx0dGhyb3cgbmV3IEVycm9yKCBgY2Fubm90IHByb2Nlc3MgcGFyYW1ldGVyLCAkeyBlcnJvci5zdGFjayB9YCApO1xuXHRcdH1cblxuXHRcdGlmKCBhcmd1bWVudC5sZW5ndGggPT0gMiApe1xuXHRcdFx0cGFyYW1ldGVyID0gWyBhcmd1bWVudFsgMCBdLCB1bmRlZmluZWQsIGFyZ3VtZW50WyAxIF0gXTtcblx0XHR9XG5cblx0XHRibHVlcHJpbnQgPSBwYXJhbWV0ZXIuc2xpY2UoIDEgKVxuXHRcdFx0LmZpbHRlciggKCBwYXJhbWV0ZXIgKSA9PiB7XG5cdFx0XHRcdHJldHVybiAoXG5cdFx0XHRcdFx0dHlwZW9mIHBhcmFtZXRlciA9PSBcImZ1bmN0aW9uXCJcblx0XHRcdFx0XHQmJiBcIm5hbWVcIiBpbiBwYXJhbWV0ZXJcblx0XHRcdFx0XHQmJiB0eXBlb2YgcGFyYW1ldGVyLm5hbWUgPT0gXCJzdHJpbmdcIlxuXHRcdFx0XHRcdCYmIHBhcmFtZXRlci5uYW1lICE9IEVNUFRZX1NUUklOR1xuXHRcdFx0XHRcdCYmIENMQVNTX05BTUVfUEFUVEVSTi50ZXN0KCBwYXJhbWV0ZXIubmFtZSApXG5cdFx0XHRcdCk7XG5cdFx0XHR9IClcblx0XHRcdC5jb25jYXQoIGJsdWVwcmludCApWyAwIF07XG5cblx0XHRsZXQgZGVmZXIgPSBwYXJzZXI7XG5cblx0XHRwYXJzZXIgPSBwYXJhbWV0ZXIuc2xpY2UoIDEgKVxuXHRcdFx0LmZpbHRlciggKCBwYXJhbWV0ZXIgKSA9PiB7XG5cdFx0XHRcdHJldHVybiAoXG5cdFx0XHRcdFx0dHlwZW9mIHBhcmFtZXRlciA9PSBcImZ1bmN0aW9uXCJcblx0XHRcdFx0XHQmJiAoXG5cdFx0XHRcdFx0XHQhKCBcIm5hbWVcIiBpbiBwYXJhbWV0ZXIgKVxuXHRcdFx0XHRcdFx0fHwgdHlwZW9mIHBhcmFtZXRlci5uYW1lICE9IFwic3RyaW5nXCJcblx0XHRcdFx0XHRcdHx8IHBhcmFtZXRlci5uYW1lID09IEVNUFRZX1NUUklOR1xuXHRcdFx0XHRcdFx0fHwgcGFyYW1ldGVyLm5hbWUgPT0gXCJhbm9ueW1vdXNcIlxuXHRcdFx0XHRcdFx0fHwgcGFyYW1ldGVyLm5hbWUgPT0gXCJwYXJzZXJcIlxuXHRcdFx0XHRcdClcblx0XHRcdFx0KTtcblx0XHRcdH0gKVxuXHRcdFx0LmNvbmNhdCggZGVmZXIgKVsgMCBdO1xuXG5cdFx0cmV0dXJuIFsgcGFyYW1ldGVyWyAwIF0sIHBhcnNlciwgZGVmZXIsIGJsdWVwcmludCBdO1xuXHR9XG5cblx0Lyo7XG5cdFx0QHN0YXRpYy1tZXRob2QtZG9jdW1lbnRhdGlvbjpcblx0XHRcdENoZWNrcyBpZiB0aGUgdGFnIGlzIGNvbXBhdGlibGUuXG5cdFx0QGVuZC1zdGF0aWMtbWV0aG9kLWRvY3VtZW50YXRpb25cblxuXHRcdEBub3RlOlxuXHRcdFx0T3ZlcnJpZGUgZm9yIHNwZWNpZmljIGNvbXBhdGliaWxpdHkgY2hlY2tpbmcuXG5cdFx0QGVuZC1ub3RlXG5cdCovXG5cdHN0YXRpYyBpc0NvbXBhdGlibGUoIHRhZyApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwidGFnXCI6IFwic3RyaW5nXCJcblx0XHRcdFx0fVxuXHRcdFx0QGVuZC1tZXRhLWNvbmZpZ3VyYXRpb25cblx0XHQqL1xuXG5cdFx0aWYoIHR5cGVvZiB0YWcgIT0gXCJzdHJpbmdcIiApe1xuXHRcdFx0cmV0dXJuIGZhbHNlO1xuXHRcdH1cblxuXHRcdHJldHVybiBUQUdfUEFUVEVSTi50ZXN0KCB0YWcgKTtcblx0fVxuXG5cdGNvbnN0cnVjdG9yKCBlbnRpdHksIG5hbWUgKXtcblx0XHQvKjtcblx0XHRcdEBtZXRhLWNvbmZpZ3VyYXRpb246XG5cdFx0XHRcdHtcblx0XHRcdFx0XHRcImVudGl0eTpyZXF1aXJlZFwiOiBcIipcIixcblx0XHRcdFx0XHRcIm5hbWU6cmVxdWlyZWRcIjogXCJzdHJpbmdcIlxuXHRcdFx0XHR9XG5cdFx0XHRAZW5kLW1ldGEtY29uZmlndXJhdGlvblxuXHRcdCovXG5cblx0XHR0aGlzLl9faW5pdGlhbGl6ZV9fKCBlbnRpdHksIG5hbWUgKTtcblx0fVxuXG5cdC8qO1xuXHRcdEBtZXRob2QtZG9jdW1lbnRhdGlvbjpcblx0XHRcdFRoaXMgaXMgYW4gaW50ZXJuYWwgaW5pdGlhbGl6YXRpb24gcHJvY2VkdXJlLlxuXG5cblx0XHRAZW5kLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cdCovXG5cdF9faW5pdGlhbGl6ZV9fKCBlbnRpdHksIG5hbWUgKXtcblx0XHQvKjtcblx0XHRcdEBtZXRhLWNvbmZpZ3VyYXRpb246XG5cdFx0XHRcdHtcblx0XHRcdFx0XHRcImVudGl0eTpyZXF1aXJlZFwiOiBcIipcIixcblx0XHRcdFx0XHRcIm5hbWU6cmVxdWlyZWRcIjogXCJzdHJpbmdcIlxuXHRcdFx0XHR9XG5cdFx0XHRAZW5kLW1ldGEtY29uZmlndXJhdGlvblxuXHRcdCovXG5cblx0XHRpZiggIXRoaXMuY2hlY2soIGVudGl0eSApICl7XG5cdFx0XHR0aHJvdyBuZXcgRXJyb3IoIFwiaW52YWxpZCBlbnRpdHlcIiApO1xuXHRcdH1cblxuXHRcdGxldCB0eXBlID0gdHlwZW9mIGVudGl0eTtcblxuXHRcdG5hbWUgPSBuYW1lIHx8IHR5cGUucmVwbGFjZSggL14uLywgKCBtYXRjaCApID0+IG1hdGNoLnRvVXBwZXJDYXNlKCApICk7XG5cblx0XHRpZiggdHlwZW9mIG5hbWUgIT0gXCJzdHJpbmdcIiApe1xuXHRcdFx0dGhyb3cgbmV3IEVycm9yKCBcImludmFsaWQgbmFtZVwiICk7XG5cdFx0fVxuXG5cdFx0dGhpc1sgVFlQRSBdID0gdHlwZTtcblx0XHR0aGlzWyBOQU1FIF0gPSBuYW1lO1xuXHRcdHRoaXNbIEVOVElUWSBdID0gZW50aXR5O1xuXG5cdFx0dGhpc1sgRVJST1IgXSA9IFsgXTtcblxuXHRcdHJldHVybiB0aGlzO1xuXHR9XG5cblx0Lyo7XG5cdFx0QG1ldGhvZC1kb2N1bWVudGF0aW9uOlxuXHRcdFx0Rm9yIGdlbmVyaWMgY2hlY2tpbmcgb2YgZW50aXR5IHRoaXMgaXMgYWx3YXlzIHRydWUsXG5cdFx0XHRcdGFuZCB0aGlzIHNob3VsZCBiZSBvdmVycmlkZGVuLlxuXHRcdEBlbmQtbWV0aG9kLWRvY3VtZW50YXRpb25cblx0Ki9cblx0Y2hlY2soIGVudGl0eSApe1xuXHRcdHJldHVybiB0cnVlO1xuXHR9XG5cblx0Lyo7XG5cdFx0QG1ldGhvZC1kb2N1bWVudGF0aW9uOlxuXHRcdFx0VGhpcyB3aWxsIG9ubHkgc3VwcG9ydCB0aHJlZSB0eXBlczsgc3RyaW5nLCBudW1iZXIsIGJvb2xlYW4uXG5cblx0XHRcdFRoZXNlIHR5cGVzIGFyZSBzZXJpYWxpemFibGUuXG5cdFx0QGVuZC1tZXRob2QtZG9jdW1lbnRhdGlvblxuXG5cdFx0QG5vdGU6XG5cdFx0XHREbyBub3Qgb3ZlcnJpZGUgdGhpcy5cblx0XHRAZW5kLW5vdGVcblx0Ki9cblx0WyBTeW1ib2wudG9QcmltaXRpdmUgXSggdHlwZSApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwidHlwZTpyZXF1aXJlZFwiOiBcInN0cmluZ1wiLFxuXHRcdFx0XHR9XG5cdFx0XHRAZW5kLW1ldGEtY29uZmlndXJhdGlvblxuXHRcdCovXG5cblx0XHRzd2l0Y2goIHR5cGUgKXtcblx0XHRcdGNhc2UgXCJzdHJpbmdcIjpcblx0XHRcdFx0cmV0dXJuIHRoaXMudG9TdHJpbmcoICk7XG5cblx0XHRcdGNhc2UgXCJudW1iZXJcIjpcblx0XHRcdFx0cmV0dXJuIHRoaXMudG9OdW1iZXIoICk7XG5cblx0XHRcdGRlZmF1bHQ6XG5cdFx0XHRcdHJldHVybiB0aGlzLnRvQm9vbGVhbiggKTtcblx0XHR9XG5cdH1cblxuXHQvKlxuXHRcdEBub3RlOlxuXHRcdFx0VGhlc2UgbWV0aG9kcyBzaG91bGQgYmUgb3ZlcnJpZGRlbi5cblx0XHRAZW5kLW5vdGVcblx0Ki9cblxuXHRnZXQgWyBTeW1ib2wudG9TdHJpbmdUYWcgXSggKXtcblx0XHRyZXR1cm4gdGhpcy5nZXROYW1lKCApO1xuXHR9XG5cblx0Lyo7XG5cdFx0QG1ldGhvZC1kb2N1bWVudGF0aW9uOlxuXHRcdFx0R2VuZXJhbGx5LCB0aGlzIHdpbGwgcmV0dXJuIHRoZSBiYXNpYyBvYmplY3QgbWV0YSBzcGVjaWZpY2F0aW9uLlxuXG5cdFx0XHRUaGUgZm9ybWF0IHByb3BlcnR5IGRpY3RhdGVzIGhvdyB0aGUgdmFsdWUgbXVzdCBiZSBpbnRlcnByZXRlZC5cblx0XHRAZW5kLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cblx0XHRAbm90ZTpcblx0XHRcdEZvciBzcGVjaWFsIHZhbHVlcyB0aGF0IG5lZWRzIHNwZWNpZmljIGNvbnZlcnNpb24gdG8gb2JqZWN0IHR5cGUsXG5cdFx0XHRcdHRoaXMgbWV0aG9kIG5lZWRzIHRvIGJlIG92ZXJyaWRkZW4uXG5cdFx0QGVuZC1ub3RlXG5cdCovXG5cdGdldCBbIE9CSkVDVCBdKCApe1xuXHRcdHJldHVybiBPYmplY3QuZnJlZXplKCB7XG5cdFx0XHRcInR5cGVcIjogdGhpcy5nZXRUeXBlKCApLFxuXHRcdFx0XCJuYW1lXCI6IHRoaXMuZ2V0TmFtZSggKSxcblx0XHRcdFwidmFsdWVcIjogdGhpcy5zZXJpYWxpemUoICksXG5cdFx0XHRcImZvcm1hdFwiOiBEQVRBX1VSTF9UQUdcblx0XHR9ICk7XG5cdH1cblxuXHRnZXQgWyBCT09MRUFOIF0oICl7XG5cdFx0cmV0dXJuIHRydWU7XG5cdH1cblxuXHRnZXQgWyBTVFJJTkcgXSggKXtcblx0XHRyZXR1cm4gT2JqZWN0LnByb3RvdHlwZS50b1N0cmluZy5jYWxsKCB0aGlzLnZhbHVlT2YoICkgKTtcblx0fVxuXG5cdGdldCBbIE5VTUJFUiBdKCApe1xuXHRcdHJldHVybiBJbmZpbml0eTtcblx0fVxuXG5cdC8qO1xuXHRcdEBnZXQtbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRSZXR1cm5zIHRoZSBvcmlnaW5hbCB2YWx1ZS5cblxuXHRcdFx0QXMgbXVjaCBhcyBwb3NzaWJsZSBkbyBub3Qgb3ZlcnJpZGUgdGhpcy5cblx0XHRAZW5kLWdldC1tZXRob2QtZG9jdW1lbnRhdGlvblxuXHQqL1xuXHRnZXQgWyBWQUxVRSBdKCApe1xuXHRcdHJldHVybiB0aGlzWyBFTlRJVFkgXTtcblx0fVxuXG5cdC8qO1xuXHRcdEBtZXRob2QtZG9jdW1lbnRhdGlvbjpcblx0XHRcdFJldHVybiBhIHN0cmluZyB0YWcgZm9ybWF0LFxuXG5cdFx0XHRcdFt0eXBlIE5hbWU6dmFsdWVdXG5cblx0XHRcdFRoZSB2YWx1ZSBpcyBvcHRpb25hbC5cblx0XHRAZW5kLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cdCovXG5cdHRhZyggdmFsdWUgKXtcblx0XHQvKjtcblx0XHRcdEBtZXRhLWNvbmZpZ3VyYXRpb246XG5cdFx0XHRcdHtcblx0XHRcdFx0XHRcInZhbHVlXCI6IFwic3RyaW5nXCJcblx0XHRcdFx0fVxuXHRcdFx0QGVuZC1tZXRhLWNvbmZpZ3VyYXRpb25cblx0XHQqL1xuXG5cdFx0aWYoIHR5cGVvZiB2YWx1ZSAhPSBcInN0cmluZ1wiICl7XG5cdFx0XHR2YWx1ZSA9IEVNUFRZX1NUUklORztcblx0XHR9XG5cblx0XHRpZiggdmFsdWUgIT0gRU1QVFlfU1RSSU5HICl7XG5cdFx0XHR2YWx1ZSA9IGA6JHsgdmFsdWUgfWA7XG5cdFx0fVxuXG5cdFx0cmV0dXJuIGBbJHsgdGhpcy5nZXRUeXBlKCApIH0gJHsgdGhpcy5nZXROYW1lKCApIH06QHZhbHVlXWAucmVwbGFjZSggXCI6QHZhbHVlXCIsIHZhbHVlICk7XG5cdH1cblxuXHQvKjtcblx0XHRAbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRSZXR1cm5zIHRoZSBvYmplY3QgY29udmVyc2lvbiBvZiB0aGlzIGRhdGEuXG5cblx0XHRcdFRoaXMgd2lsbCBiZSB1c2VkIG9uIEpTT04uc3RyaW5naWZ5IG1ldGhvZC5cblx0XHRAZW5kLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cdCovXG5cdHRvSlNPTiggKXtcblx0XHRyZXR1cm4gdGhpc1sgT0JKRUNUIF07XG5cdH1cblxuXHQvKjtcblx0XHRAbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRSZXR1cm5zIHRoZSBvYmplY3QgY29udmVyc2lvbiBvZiB0aGlzIGRhdGEuXG5cdFx0QGVuZC1tZXRob2QtZG9jdW1lbnRhdGlvblxuXHQqL1xuXHR0b09iamVjdCggKXtcblx0XHRyZXR1cm4gdGhpc1sgT0JKRUNUIF07XG5cdH1cblxuXHQvKjtcblx0XHRAbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRSZXR1cm5zIHRoZSBib29sZWFuIGNvbnZlcnNpb24gb2YgdGhpcyBkYXRhLlxuXHRcdEBlbmQtbWV0aG9kLWRvY3VtZW50YXRpb25cblxuXHRcdEBub3RlOlxuXHRcdFx0QXMgbXVjaCBhcyBwb3NzaWJsZSwgZG8gbm90IG92ZXJyaWRlIHRoaXMgbWV0aG9kLlxuXHRcdEBlbmQtbm90ZVxuXHQqL1xuXHR0b0Jvb2xlYW4oICl7XG5cdFx0cmV0dXJuIHRoaXNbIEJPT0xFQU4gXTtcblx0fVxuXG5cdC8qO1xuXHRcdEBtZXRob2QtZG9jdW1lbnRhdGlvbjpcblx0XHRcdFJldHVybnMgdGhlIHN0cmluZyBjb252ZXJzaW9uIG9mIHRoaXMgZGF0YS5cblx0XHRAZW5kLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cblx0XHRAbm90ZTpcblx0XHRcdEFzIG11Y2ggYXMgcG9zc2libGUsIGRvIG5vdCBvdmVycmlkZSB0aGlzIG1ldGhvZC5cblx0XHRAZW5kLW5vdGVcblx0Ki9cblx0dG9TdHJpbmcoICl7XG5cdFx0cmV0dXJuIHRoaXNbIFNUUklORyBdO1xuXHR9XG5cblx0Lyo7XG5cdFx0QG1ldGhvZC1kb2N1bWVudGF0aW9uOlxuXHRcdFx0UmV0dXJucyB0aGUgbnVtZXJpY2FsIGNvbnZlcnNpb24gb2YgdGhpcyBkYXRhLlxuXHRcdEBlbmQtbWV0aG9kLWRvY3VtZW50YXRpb25cblxuXHRcdEBub3RlOlxuXHRcdFx0QXMgbXVjaCBhcyBwb3NzaWJsZSwgZG8gbm90IG92ZXJyaWRlIHRoaXMgbWV0aG9kLlxuXHRcdEBlbmQtbm90ZVxuXHQqL1xuXHR0b051bWJlciggKXtcblx0XHRyZXR1cm4gdGhpc1sgTlVNQkVSIF07XG5cdH1cblxuXHQvKjtcblx0XHRAbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRSZXR1cm5zIHRoZSBvcmlnaW5hbCB2YWx1ZS5cblx0XHRAZW5kLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cblx0XHRAbm90ZTpcblx0XHRcdEFzIG11Y2ggYXMgcG9zc2libGUsIGRvIG5vdCBvdmVycmlkZSB0aGlzIG1ldGhvZC5cblx0XHRAZW5kLW5vdGVcblx0Ki9cblx0dmFsdWVPZiggKXtcblx0XHRyZXR1cm4gdGhpc1sgVkFMVUUgXTtcblx0fVxuXG5cdHR5cGVPZiggdHlwZSApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwidHlwZTpyZXF1aXJlZFwiOiBcInN0cmluZ1wiXG5cdFx0XHRcdH1cblx0XHRcdEBlbmQtbWV0YS1jb25maWd1cmF0aW9uXG5cdFx0Ki9cblxuXHRcdGlmKCB0eXBlb2YgdHlwZSA9PSBcInN0cmluZ1wiICl7XG5cdFx0XHRyZXR1cm4gdHlwZW9mIHRoaXMudmFsdWVPZiggKSA9PSB0eXBlO1xuXHRcdH1cblxuXHRcdHJldHVybiBmYWxzZTtcblx0fVxuXG5cdC8qXG5cdFx0QG5vdGU6XG5cdFx0XHRTb21lIGNhc2VzIHRoYXQgaW5zdGFuY2VPZiBuZWVkcyB0byBiZSBvdmVycmlkZGVuLlxuXHRcdEBlbmQtbm90ZVxuXHQqL1xuXHRpbnN0YW5jZU9mKCBibHVlcHJpbnQgKXtcblx0XHQvKjtcblx0XHRcdEBtZXRhLWNvbmZpZ3VyYXRpb246XG5cdFx0XHRcdHtcblx0XHRcdFx0XHRcImJsdWVwcmludDpyZXF1aXJlZFwiOiBbXG5cdFx0XHRcdFx0XHRcImZ1bmN0aW9uXCIsXG5cdFx0XHRcdFx0XHRcInN0cmluZ1wiXG5cdFx0XHRcdFx0XVxuXHRcdFx0XHR9XG5cdFx0XHRAZW5kLW1ldGEtY29uZmlndXJhdGlvblxuXHRcdCovXG5cblx0XHRsZXQgZW50aXR5ID0gdGhpcy52YWx1ZU9mKCApO1xuXG5cdFx0aWYoIHR5cGVvZiBibHVlcHJpbnQgPT0gXCJmdW5jdGlvblwiICl7XG5cdFx0XHRyZXR1cm4gKFxuXHRcdFx0XHR0aGlzIGluc3RhbmNlb2YgYmx1ZXByaW50XG5cdFx0XHRcdHx8IGVudGl0eSBpbnN0YW5jZW9mIGJsdWVwcmludFxuXHRcdFx0XHR8fCB0eXBlb2YgYmx1ZXByaW50Lm5hbWUgPT0gXCJzdHJpbmdcIiAmJiB0aGlzLmluc3RhbmNlT2YoIGJsdWVwcmludC5uYW1lIClcblx0XHRcdCk7XG5cdFx0fVxuXG5cdFx0aWYoIHR5cGVvZiBibHVlcHJpbnQgPT0gXCJzdHJpbmdcIiApe1xuXHRcdFx0aWYoIHRoaXMudHlwZU9mKCBibHVlcHJpbnQudG9Mb3dlckNhc2UoICkgKSApe1xuXHRcdFx0XHRyZXR1cm4gdHJ1ZTtcblx0XHRcdH1cblxuXHRcdFx0aWYoIGVudGl0eSA9PT0gbnVsbCB8fCB0eXBlb2YgZW50aXR5ID09IFwidW5kZWZpbmVkXCIgKXtcblx0XHRcdFx0cmV0dXJuIGZhbHNlO1xuXHRcdFx0fVxuXG5cdFx0XHRpZiggdHlwZW9mIGVudGl0eSA9PSBcImZ1bmN0aW9uXCIgJiYgZW50aXR5Lm5hbWUgPT09IGJsdWVwcmludCApe1xuXHRcdFx0XHRyZXR1cm4gdHJ1ZTtcblx0XHRcdH1cblxuXHRcdFx0ZG97XG5cdFx0XHRcdGlmKCAoXG5cdFx0XHRcdFx0dHlwZW9mIGVudGl0eSA9PSBcImZ1bmN0aW9uXCJcblx0XHRcdFx0XHQmJiBlbnRpdHkubmFtZSA9PT0gYmx1ZXByaW50XG5cdFx0XHRcdCkgfHwgKFxuXHRcdFx0XHRcdHR5cGVvZiBlbnRpdHkuY29uc3RydWN0b3IgPT0gXCJmdW5jdGlvblwiXG5cdFx0XHRcdFx0JiYgZW50aXR5LmNvbnN0cnVjdG9yLm5hbWUgPT09IGJsdWVwcmludFxuXHRcdFx0XHQpICl7XG5cdFx0XHRcdFx0cmV0dXJuIHRydWU7XG5cdFx0XHRcdH1cblx0XHRcdH13aGlsZSggZW50aXR5ID0gT2JqZWN0LmdldFByb3RvdHlwZU9mKCBlbnRpdHkgKSApO1xuXG5cdFx0XHQvKjtcblx0XHRcdFx0QG5vdGU6XG5cdFx0XHRcdFx0SWYgeW91IHJlbW92ZWQgdGhlIGNvbmRpdGlvbiwgdGhpcyBtYXkgY2F1c2UgdW53YW50ZWQgYmVoYXZpb3IuXG5cdFx0XHRcdEBlbmQtbm90ZVxuXHRcdFx0Ki9cblx0XHRcdGlmKCB0aGlzLmNvbnN0cnVjdG9yLm5hbWUgIT0gYmx1ZXByaW50ICl7XG5cdFx0XHRcdGxldCBlbnRpdHkgPSB0aGlzO1xuXG5cdFx0XHRcdGRve1xuXHRcdFx0XHRcdGlmKCAoXG5cdFx0XHRcdFx0XHR0eXBlb2YgZW50aXR5ID09IFwiZnVuY3Rpb25cIlxuXHRcdFx0XHRcdFx0JiYgZW50aXR5Lm5hbWUgPT09IGJsdWVwcmludFxuXHRcdFx0XHRcdCkgfHwgKFxuXHRcdFx0XHRcdFx0dHlwZW9mIGVudGl0eS5jb25zdHJ1Y3RvciA9PSBcImZ1bmN0aW9uXCJcblx0XHRcdFx0XHRcdCYmIGVudGl0eS5jb25zdHJ1Y3Rvci5uYW1lID09PSBibHVlcHJpbnRcblx0XHRcdFx0XHQpICl7XG5cdFx0XHRcdFx0XHRyZXR1cm4gdHJ1ZTtcblx0XHRcdFx0XHR9XG5cdFx0XHRcdH13aGlsZSggZW50aXR5ID0gT2JqZWN0LmdldFByb3RvdHlwZU9mKCBlbnRpdHkgKSApO1xuXHRcdFx0fVxuXG5cdFx0XHRyZXR1cm4gZmFsc2U7XG5cdFx0fVxuXG5cdFx0cmV0dXJuIGZhbHNlO1xuXHR9XG5cblx0Lyo7XG5cdFx0QG5vdGU6XG5cdFx0XHRUaGlzIGlzIHRoZSBnZW5lcmljIHN0cmluZ2lmeSBmdW5jdGlvbixcblx0XHRcdFx0Zm9yIGNvbXBsZXggZW50aXR5IHlvdSBuZWVkIHRvIG92ZXJyaWRlIHRoaXMuXG5cdFx0QGVuZC1ub3RlXG5cdCovXG5cdHN0cmluZ2lmeSggKXtcblx0XHR0cnl7XG5cdFx0XHRpZiggdGhpcy5nZXRUeXBlKCApID09IFwib2JqZWN0XCIgKXtcblx0XHRcdFx0cmV0dXJuIEpTT04uc3RyaW5naWZ5KCB0aGlzLnZhbHVlT2YoICkgKTtcblx0XHRcdH1cblxuXHRcdFx0cmV0dXJuIEVNUFRZX1NUUklORyArIHRoaXMudmFsdWVPZiggKTtcblxuXHRcdH1jYXRjaCggZXJyb3IgKXtcblx0XHRcdHRyeXtcblx0XHRcdFx0cmV0dXJuIHRoaXMudmFsdWVPZiggKS50b1N0cmluZyggKTtcblxuXHRcdFx0fWNhdGNoKCBlcnJvciApe1xuXHRcdFx0XHRyZXR1cm4gdGhpcy50b1N0cmluZyggKTtcblx0XHRcdH1cblx0XHR9XG5cdH1cblxuXHQvKjtcblx0XHRAbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRUaGlzIHdpbGwgY2FsbCB0aGUgc3RhdGljIGRlc2VyaWFsaXphdGlvbiBwcm9jZWR1cmUgb2YgdGhlIGNvbnN0cnVjdG9yLlxuXHRcdEBlbmQtbWV0aG9kLWRvY3VtZW50YXRpb25cblx0Ki9cblx0ZGVzZXJpYWxpemUoIGRhdGEsIHBhcnNlciwgYmx1ZXByaW50ICl7XG5cdFx0Lyo7XG5cdFx0XHRAbWV0YS1jb25maWd1cmF0aW9uOlxuXHRcdFx0XHR7XG5cdFx0XHRcdFx0XCJkYXRhXCI6IFwiKlwiLFxuXHRcdFx0XHRcdFwicGFyc2VyXCI6IFwiZnVuY3Rpb25cIixcblx0XHRcdFx0XHRcImJsdWVwcmludFwiOiBcImZ1bmN0aW9uXCJcblx0XHRcdFx0fVxuXHRcdFx0QGVuZC1tZXRhLWNvbmZpZ3VyYXRpb25cblx0XHQqL1xuXG5cdFx0bGV0IHByb2NlZHVyZSA9IE1ldGEuZGVzZXJpYWxpemU7XG5cblx0XHRpZihcblx0XHRcdHR5cGVvZiB0aGlzLmNvbnN0cnVjdG9yID09IFwiZnVuY3Rpb25cIlxuXHRcdFx0JiYgdHlwZW9mIHRoaXMuY29uc3RydWN0b3IuZGVzZXJpYWxpemUgPT0gXCJmdW5jdGlvblwiXG5cdFx0XHQmJiB0aGlzLmNvbnN0cnVjdG9yLmRlc2VyaWFsaXplLm5hbWUgPT09IFwiZGVzZXJpYWxpemVcIlxuXHRcdCl7XG5cdFx0XHRwcm9jZWR1cmUgPSB0aGlzLmNvbnN0cnVjdG9yLmRlc2VyaWFsaXplO1xuXHRcdH1cblxuXHRcdGlmKCBhcmd1bWVudHMubGVuZ3RoID09IDIgKXtcblx0XHRcdHJldHVybiBwcm9jZWR1cmUoIHRoaXMudmFsdWVPZiggKSwgYXJndW1lbnRzWyAwIF0sIGFyZ3VtZW50c1sgMSBdICk7XG5cblx0XHR9ZWxzZXtcblx0XHRcdHJldHVybiBwcm9jZWR1cmUoIGRhdGEsIHBhcnNlciwgYmx1ZXByaW50ICk7XG5cdFx0fVxuXHR9XG5cblx0Lyo7XG5cdFx0QHN0YXRpYy1tZXRob2QtZG9jdW1lbnRhdGlvbjpcblx0XHRcdERlZmF1bHQgZ2VuZXJpYyBzZXJpYWxpemF0aW9uIGludGVycHJldGVyLlxuXHRcdEBlbmQtc3RhdGljLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cdCovXG5cdHN0YXRpYyBpbnRlcnByZXRlciggc2VsZiApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwic2VsZlwiOiBNZXRhXG5cdFx0XHRcdH1cblx0XHRcdEBlbmQtbWV0YS1jb25maWd1cmF0aW9uXG5cdFx0Ki9cblxuXHRcdGxldCB2YWx1ZSA9IHN4dHk0KCBzZWxmLnN0cmluZ2lmeSggKSApLmVuY29kZSggKTtcblxuXHRcdHJldHVybiBgJHsgREVGQVVMVF9EQVRBX1VSTF9QUkVGSVgucmVwbGFjZSggXCJAdHlwZVwiLCBzZWxmLmdldFR5cGUoICkgKSB9JHsgdmFsdWUgfWA7XG5cdH1cblxuXHQvKjtcblx0XHRAbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRSZXR1cm5zIGEgdGFnIGZvcm1hdCB3aXRoIHZhbHVlLlxuXHRcdFx0VGhlIHZhbHVlIG11c3QgYmUgYSBkYXRhIFVSTCBmb3JtYXQuXG5cblx0XHRcdFRoZSBpbnRlcnByZXRlciBmdW5jdGlvbiB3aWxsIGFjY2VwdCBhIGNvbnRleHQgcGFyYW1ldGVyLlxuXG5cdFx0XHRCeSBkZWZhdWx0IHRoaXMgd2lsbCBzZXJpYWxpemUgdGhlIGVudGl0eSB1c2luZyBwbGFpbi90ZXh0IGJhc2U2NCBkYXRhIFVSTCBmb3JtYXQuXG5cblx0XHRcdFRoZSBpbnRlcnByZXRlciBtdXN0IHJldHVybiBhIHNlcmlhbGl6ZSBmb3JtYXQgb2YgdGhlIGRhdGEgdG8gYmUgcGxhY2VkIG9uIHRoZSB0YWcuXG5cdFx0QGVuZC1tZXRob2QtZG9jdW1lbnRhdGlvblxuXHQqL1xuXHRzZXJpYWxpemUoIGludGVycHJldGVyICl7XG5cdFx0Lyo7XG5cdFx0XHRAbWV0YS1jb25maWd1cmF0aW9uOlxuXHRcdFx0XHR7XG5cdFx0XHRcdFx0XCJpbnRlcnByZXRlclwiOiBcImZ1bmN0aW9uXCJcblx0XHRcdFx0fVxuXHRcdFx0QGVuZC1tZXRhLWNvbmZpZ3VyYXRpb25cblx0XHQqL1xuXG5cdFx0bGV0IGRlZmVyID0gTWV0YS5pbnRlcnByZXRlcjtcblxuXHRcdGlmKCB0eXBlb2YgaW50ZXJwcmV0ZXIgIT0gXCJmdW5jdGlvblwiICl7XG5cdFx0XHRpbnRlcnByZXRlciA9IGRlZmVyO1xuXHRcdH1cblxuXHRcdHRyeXtcblx0XHRcdHJldHVybiB0aGlzLnRhZyggaW50ZXJwcmV0ZXIoIHRoaXMgKSApO1xuXG5cdFx0fWNhdGNoKCBlcnJvciApe1xuXHRcdFx0cmV0dXJuIHRoaXMudGFnKCBkZWZlciggdGhpcyApICk7XG5cdFx0fVxuXHR9XG5cblx0Lyo7XG5cdFx0QG1ldGhvZC1kb2N1bWVudGF0aW9uOlxuXHRcdFx0U3RyaWN0IHZhbHVlIGVxdWFsaXR5LlxuXHRcdEBlbmQtbWV0aG9kLWRvY3VtZW50YXRpb25cblxuXHRcdEBub3RlOlxuXHRcdFx0T3ZlcnJpZGUgZm9yIGRlZXAgY2hlY2tpbmcuXG5cdFx0QGVuZC1ub3RlXG5cdCovXG5cdGlzRXF1YWwoIGVudGl0eSApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwiZW50aXR5OnJlcXVpcmVkXCI6IFwiKlwiXG5cdFx0XHRcdH1cblx0XHRcdEBlbmQtbWV0YS1jb25maWd1cmF0aW9uXG5cdFx0Ki9cblxuXHRcdGlmKCBlbnRpdHkgaW5zdGFuY2VvZiBNZXRhICl7XG5cdFx0XHRyZXR1cm4gdGhpcy52YWx1ZU9mKCApID09PSBlbnRpdHkudmFsdWVPZiggKTtcblx0XHR9XG5cblx0XHRyZXR1cm4gdGhpcy52YWx1ZU9mKCApID09PSBlbnRpdHk7XG5cdH1cblxuXHQvKjtcblx0XHRAbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRXaGVuIHRoZSBkZXNlcmlhbGl6YXRpb24gZmFpbHMsIG9yIGlmIHRoZXJlIGlzIGVycm9yLCB0aGlzIG1ldGhvZCByZXR1cm5zIHRydWUuXG5cdFx0QGVuZC1tZXRob2QtZG9jdW1lbnRhdGlvblxuXHQqL1xuXHRpc0NvcnJ1cHRlZCggKXtcblx0XHRyZXR1cm4gKFxuXHRcdFx0dGhpc1sgQ09SUlVQVEVEIF0gPT09IENPUlJVUFRFRFxuXHRcdFx0fHwgdGhpcy5oYXNFcnJvciggKVxuXHRcdCk7XG5cdH1cblxuXHRpc1RhZ2dlZCggKXtcblx0XHRyZXR1cm4gKFxuXHRcdFx0dGhpc1sgVEFHR0VEIF0gPT09IFRBR0dFRFxuXHRcdFx0fHwgVEFHX1BBVFRFUk4udGVzdCggdGhpcy5zdHJpbmdpZnkoICkgKVxuXHRcdCk7XG5cdH1cblxuXHQvKjtcblx0XHRAbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRJZiB0aGUgZW50aXR5IGlzIG5vdCBhIHRhZyBmb3JtYXQgdGhlbiBpdCdzIHJhdy5cblx0XHRAZW5kLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cdCovXG5cdGlzUmF3KCApe1xuXHRcdHJldHVybiAhdGhpcy5pc1RhZ2dlZCggKTtcblx0fVxuXG5cdHNldEVycm9yKCBlcnJvciApe1xuXHRcdGlmKCBlcnJvciBpbnN0YW5jZW9mIEVycm9yICl7XG5cdFx0XHR0aGlzLnB1c2hFcnJvciggZXJyb3IgKTtcblx0XHR9XG5cblx0XHRyZXR1cm4gdGhpcztcblx0fVxuXG5cdHB1c2hFcnJvciggZXJyb3IgKXtcblx0XHRpZiggZXJyb3IgaW5zdGFuY2VvZiBFcnJvciApe1xuXHRcdFx0dGhpc1sgRVJST1IgXS5wdXNoKCBlcnJvciApO1xuXHRcdH1cblxuXHRcdHJldHVybiB0aGlzO1xuXHR9XG5cblx0Z2V0RXJyb3IoICl7XG5cdFx0cmV0dXJuIHRoaXNbIEVSUk9SIF0ucmV2ZXJzZSggKVsgMCBdO1xuXHR9XG5cblx0aGFzRXJyb3IoICl7XG5cdFx0cmV0dXJuIHRoaXNbIEVSUk9SIF0ubGVuZ3RoID4gMDtcblx0fVxuXG5cdHRyYW5zZmVyRXJyb3IoIGNvbnRhaW5lciApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwiY29udGFpbmVyXCI6IEFycmF5XG5cdFx0XHRcdH1cblx0XHRcdEBlbmQtbWV0YS1jb25maWd1cmF0aW9uXG5cdFx0Ki9cblxuXHRcdGlmKCBjb250YWluZXIgaW5zdGFuY2VvZiBBcnJheSApe1xuXHRcdFx0bGV0IGxpc3QgPSB0aGlzWyBFUlJPUiBdLnJldmVyc2UoICk7XG5cdFx0XHRsZXQgaW5kZXggPSBsaXN0Lmxlbmd0aDtcblx0XHRcdHdoaWxlKCBpbmRleC0tICkgY29udGFpbmVyLnB1c2goIGxpc3RbIGluZGV4IF0gKTtcblx0XHR9XG5cblx0XHRyZXR1cm4gdGhpcztcblx0fVxuXG5cdC8qO1xuXHRcdEBtZXRob2QtZG9jdW1lbnRhdGlvbjpcblx0XHRcdFJldHVybnMgdGhlIGNsb25lIG9mIHRoaXMgZGF0YS5cblx0XHRAZW5kLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cdCovXG5cdGNsb25lKCBzdGF0ZSApe1xuXHRcdC8qO1xuXHRcdFx0QG1ldGEtY29uZmlndXJhdGlvbjpcblx0XHRcdFx0e1xuXHRcdFx0XHRcdFwic3RhdGVcIjogQXJyYXlcblx0XHRcdFx0fVxuXHRcdFx0QGVuZC1tZXRhLWNvbmZpZ3VyYXRpb25cblx0XHQqL1xuXG5cdFx0cmV0dXJuIE1ldGEuY3JlYXRlKCB0aGlzLmNvbnN0cnVjdG9yLCB0aGlzLnZhbHVlT2YoICksIHN0YXRlICk7XG5cdH1cblxuXHQvKjtcblx0XHRAbWV0aG9kLWRvY3VtZW50YXRpb246XG5cdFx0XHRSZXR1cm5zIHRoZSBNZXRhIGluc3RhbmNlIG9mIHRoaXMgZGF0YS5cblx0XHRAZW5kLW1ldGhvZC1kb2N1bWVudGF0aW9uXG5cdCovXG5cdG5hdGl2ZSggc3RhdGUgKXtcblx0XHQvKjtcblx0XHRcdEBtZXRhLWNvbmZpZ3VyYXRpb246XG5cdFx0XHRcdHtcblx0XHRcdFx0XHRcInN0YXRlXCI6IEFycmF5XG5cdFx0XHRcdH1cblx0XHRcdEBlbmQtbWV0YS1jb25maWd1cmF0aW9uXG5cdFx0Ki9cblxuXHRcdHJldHVybiBNZXRhLmNyZWF0ZSggTWV0YSwgdGhpcy52YWx1ZU9mKCApLCBzdGF0ZSApO1xuXHR9XG5cblx0Lyo7XG5cdFx0QG1ldGhvZC1kb2N1bWVudGF0aW9uOlxuXHRcdFx0UmV2ZXJ0cyB0byB0aGUgTWV0YSBpbnN0YW5jZSBvZiB0aGlzIGRhdGEsXG5cdFx0XHRcdHBhc3NpbmcgdGhlIGluY3VycmVkIHN0YXRlIGZyb20gcHJldmlvdXMuXG5cdFx0QGVuZC1tZXRob2QtZG9jdW1lbnRhdGlvblxuXHQqL1xuXHRyZXZlcnQoICl7XG5cdFx0bGV0IHN0YXRlID0gWyBdO1xuXG5cdFx0aWYoIHRoaXMuaXNDb3JydXB0ZWQoICkgKXtcblx0XHRcdHN0YXRlLnB1c2goIENPUlJVUFRFRCApO1xuXHRcdH1cblxuXHRcdGlmKCB0aGlzLmhhc0Vycm9yKCApICl7XG5cdFx0XHR0aGlzLnRyYW5zZmVyRXJyb3IoIHN0YXRlICk7XG5cdFx0fVxuXG5cdFx0cmV0dXJuIHRoaXMubmF0aXZlKCBzdGF0ZSApO1xuXHR9XG5cblx0Z2V0VHlwZSggKXtcblx0XHRyZXR1cm4gdGhpc1sgVFlQRSBdO1xuXHR9XG5cblx0Z2V0TmFtZSggKXtcblx0XHRyZXR1cm4gdGhpc1sgTkFNRSBdO1xuXHR9XG59XG5cbmhhcmRlbiggXCJOQU1FXCIsIE5BTUUsIE1ldGEgKTtcbmhhcmRlbiggXCJFTlRJVFlcIiwgRU5USVRZLCBNZXRhICk7XG5oYXJkZW4oIFwiVFlQRVwiLCBUWVBFLCBNZXRhICk7XG5cbmhhcmRlbiggXCJPQkpFQ1RcIiwgT0JKRUNULCBNZXRhICk7XG5oYXJkZW4oIFwiQk9PTEVBTlwiLCBCT09MRUFOLCBNZXRhICk7XG5oYXJkZW4oIFwiU1RSSU5HXCIsIFNUUklORywgTWV0YSApO1xuaGFyZGVuKCBcIk5VTUJFUlwiLCBOVU1CRVIsIE1ldGEgKTtcbmhhcmRlbiggXCJWQUxVRVwiLCBWQUxVRSwgTWV0YSApO1xuXG5oYXJkZW4oIFwiR0FSQkFHRVwiLCBHQVJCQUdFLCBNZXRhICk7XG5oYXJkZW4oIFwiQ09SUlVQVEVEXCIsIENPUlJVUFRFRCwgTWV0YSApO1xuaGFyZGVuKCBcIlRBR0dFRFwiLCBUQUdHRUQsIE1ldGEgKTtcblxuaGFyZGVuKCBcIlRBR19QQVRURVJOXCIsIFRBR19QQVRURVJOLCBNZXRhICk7XG5cbmhhcmRlbiggXCJEQVRBX1VSTF9UQUdcIiwgREFUQV9VUkxfVEFHLCBNZXRhICk7XG5cbm1vZHVsZS5leHBvcnRzID0gTWV0YTtcbiJdfQ==


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(61), __esModule: true };

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40);
module.exports = __webpack_require__(10).f('toStringTag');


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(63), __esModule: true };

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(65);
module.exports = __webpack_require__(0).Object.getPrototypeOf;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(20);
var $getPrototypeOf = __webpack_require__(22);

__webpack_require__(24)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(68), __esModule: true };

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(10).f('toPrimitive');


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(70);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(83);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(71), __esModule: true };

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27);
__webpack_require__(17);
module.exports = __webpack_require__(82);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(73);
var step = __webpack_require__(74);
var Iterators = __webpack_require__(12);
var toIObject = __webpack_require__(9);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(44)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(28);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(30);
var descriptor = __webpack_require__(14);
var setToStringTag = __webpack_require__(33);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(11)(IteratorPrototype, __webpack_require__(1)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(2);
var anObject = __webpack_require__(6);
var getKeys = __webpack_require__(16);

module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(9);
var toLength = __webpack_require__(47);
var toAbsoluteIndex = __webpack_require__(79);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(31);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(31);
var defined = __webpack_require__(21);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(48);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(12);
module.exports = __webpack_require__(0).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(84), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27);
__webpack_require__(17);
module.exports = __webpack_require__(85);


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var get = __webpack_require__(49);
module.exports = __webpack_require__(0).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(87), __esModule: true };

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88);
module.exports = __webpack_require__(0).Object.freeze;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(50).onFreeze;

__webpack_require__(24)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(90), __esModule: true };

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17);
__webpack_require__(91);
module.exports = __webpack_require__(0).Array.from;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(25);
var $export = __webpack_require__(5);
var toObject = __webpack_require__(20);
var call = __webpack_require__(92);
var isArrayIter = __webpack_require__(93);
var toLength = __webpack_require__(47);
var createProperty = __webpack_require__(94);
var getIterFn = __webpack_require__(49);

$export($export.S + $export.F * !__webpack_require__(95)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(6);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(12);
var ITERATOR = __webpack_require__(1)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(2);
var createDesc = __webpack_require__(14);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(1)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(97), __esModule: true };

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17);
__webpack_require__(27);
module.exports = __webpack_require__(10).f('iterator');


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51);
__webpack_require__(40);
__webpack_require__(102);
__webpack_require__(103);
module.exports = __webpack_require__(0).Symbol;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(16);
var toIObject = __webpack_require__(9);
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) if (O[key = keys[index++]] === el) return key;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(16);
var gOPS = __webpack_require__(52);
var pIE = __webpack_require__(36);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(28);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35)('asyncIterator');


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35)('observable');


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(105), __esModule: true };

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
module.exports = __webpack_require__(10).f('hasInstance');


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(22);
var HAS_INSTANCE = __webpack_require__(1)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(2).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperty: __webpack_require__(2).f });


/***/ }),
/* 109 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(111), __esModule: true };

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51);
module.exports = __webpack_require__(0).Object.getOwnPropertySymbols;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(113), __esModule: true };

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(114);
var $Object = __webpack_require__(0).Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(24)('getOwnPropertyNames', function () {
  return __webpack_require__(53).f;
});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*;
              	@module-license:
              		The MIT License (MIT)
              		@mit-license
              
              		Copyright (@c) 2017 Richeve Siodina Bebedor
              		@email: richeve.bebedor@gmail.com
              
              		Permission is hereby granted, free of charge, to any person obtaining a copy
              		of this software and associated documentation files (the "Software"), to deal
              		in the Software without restriction, including without limitation the rights
              		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              		copies of the Software, and to permit persons to whom the Software is
              		furnished to do so, subject to the following conditions:
              
              		The above copyright notice and this permission notice shall be included in all
              		copies or substantial portions of the Software.
              
              		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              		SOFTWARE.
              	@end-module-license
              
              	@module-configuration:
              		{
              			"package": "sxty4",
              			"path": "sxty4/sxty4.js",
              			"file": "sxty4.js",
              			"module": "sxty4",
              			"author": "Richeve S. Bebedor",
              			"contributors": [
              				"John Lenon Maghanoy <johnlenonmaghanoy@gmail.com>",
              				"Vinse Vinalon"
              			],
              			"eMail": "richeve.bebedor@gmail.com",
              			"repository": "https://github.com/volkovasystems/sxty4.git",
              			"test": "test.module.js",
              			"global": true
              		}
              	@end-module-configuration
              
              	@module-documentation:
              		Base 64 string encoding and decoding with url safety.
              	@end-module-documentation
              
              	@include:
              		{
              			"falzy": "falzy",
              			"harden": "harden"
              		}
              	@end-include
              */

var falzy = __webpack_require__(57);
var harden = __webpack_require__(39);



//: @client:
var Base64 = __webpack_require__(116);
//: @end-client

var sxty4 = function sxty4(data) {
	/*;
                                  	@meta-configuration:
                                  		{
                                  			"data:required": "string"
                                  		}
                                  	@end-meta-configuration
                                  */

	if (falzy(data) || typeof data != "string") {
		throw new Error("invalid data");
	}

	return new Base64(data);
};

harden("Base64", Base64, sxty4);

module.exports = sxty4;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*;
              	@submodule-license:
              		The MIT License (MIT)
              		@mit-license
              
              		Copyright (@c) 2017 Richeve Siodina Bebedor
              		@email: richeve.bebedor@gmail.com
              
              		Permission is hereby granted, free of charge, to any person obtaining a copy
              		of this software and associated documentation files (the "Software"), to deal
              		in the Software without restriction, including without limitation the rights
              		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              		copies of the Software, and to permit persons to whom the Software is
              		furnished to do so, subject to the following conditions:
              
              		The above copyright notice and this permission notice shall be included in all
              		copies or substantial portions of the Software.
              
              		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              		SOFTWARE.
              	@end-submodule-license
              
              	@submodule-configuration:
              		{
              			"package": "sxty4",
              			"path": "sxty4/base64.module.js",
              			"file": "base64.module.js",
              			"module": "sxty4",
              			"author": "Richeve S. Bebedor",
              			"eMail": "richeve.bebedor@gmail.com",
              			"contributors": [
              				"John Lenon Maghanoy <johnlenonmaghanoy@gmail.com>",
              				"Vinse Vinalon <vinsevinalon@gmail.com>"
              			],
              			"repository": "https://github.com/volkovasystems/sxty4.git",
              			"test": "test.module.js",
              			"global": false,
              			"internal": true,
              			"class": true
              		}
              	@end-submodule-configuration
              
              	@submodule-documentation:
              		Base64 class
              	@end-submodule-documentation
              
              	@include:
              		{
              			"bse": "bse",
              			"harden": "harden"
              		}
              	@end-include
              */var _getPrototypeOf = __webpack_require__(41);var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);var _classCallCheck2 = __webpack_require__(37);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(38);var _createClass3 = _interopRequireDefault(_createClass2);var _possibleConstructorReturn2 = __webpack_require__(117);var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);var _inherits2 = __webpack_require__(118);var _inherits3 = _interopRequireDefault(_inherits2);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var harden = __webpack_require__(39);

var Base = __webpack_require__(126)();

var BASE = 64;
var EMPTY_STRING = "";var

Base64 = function (_Base) {(0, _inherits3.default)(Base64, _Base);
	function Base64(data) {(0, _classCallCheck3.default)(this, Base64);return (0, _possibleConstructorReturn3.default)(this, (Base64.__proto__ || (0, _getPrototypeOf2.default)(Base64)).call(this,
		data, BASE));
	}(0, _createClass3.default)(Base64, [{ key: "encode", value: function encode(

		done) {
			/*;
         	@meta-configuration:
         		{
         			"done": "function"
         		}
         	@end-meta-configuration
         */

			this.setEncodeMode();

			var data = this.getData();

			var result = EMPTY_STRING;

			try {


				//: @client:
				result = encodeURIComponent(btoa(encodeURIComponent(data).
				replace(/%([0-9A-F]{2})/g, function (match, token) {
					return String.fromCharCode("0x" + token);
				})));
				//: @end-client

				if (typeof done == "function") {
					done.call(this, null, result);

					return this;

				} else {
					return result;
				}

			} catch (error) {
				error = new Error("cannot encode to base64, " + data + ", " + error.stack);

				this.setError(error);

				if (typeof done == "function") {
					done.call(this, error, EMPTY_STRING);

					return this;

				} else {
					return EMPTY_STRING;
				}

			} finally {
				this.setResult(result);

				done = undefined;
			}
		} }, { key: "decode", value: function decode(

		done) {
			/*;
         	@meta-configuration:
         		{
         			"done": "function"
         		}
         	@end-meta-configuration
         */

			this.setDecodeMode();

			var data = this.getData();

			var result = EMPTY_STRING;

			try {


				//: @client:
				result = decodeURIComponent(atob(decodeURIComponent(data)).
				split("").map(function (character) {
					character = ("00" + character.charCodeAt(0).toString(16)).slice(-2);

					return "%" + character;
				}).join(""));
				//: @end-client

				if (typeof done == "function") {
					done.call(this, null, result);

					return this;

				} else {
					return result;
				}

			} catch (error) {
				error = new Error("cannot decode from base64, " + data + ", " + error.stack);

				this.setError(error);

				if (typeof done == "function") {
					done.call(this, error, EMPTY_STRING);

					return this;

				} else {
					return EMPTY_STRING;
				}

			} finally {
				this.setResult(result);
			}
		} }]);return Base64;}(Base);


harden("Base64", Base64, Base);

module.exports = Base64;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(18);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(119);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(123);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(18);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(120), __esModule: true };

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(121);
module.exports = __webpack_require__(0).Object.setPrototypeOf;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(5);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(122).set });


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(7);
var anObject = __webpack_require__(6);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(25)(Function.call, __webpack_require__(55).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(124), __esModule: true };

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(125);
var $Object = __webpack_require__(0).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(30) });


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*;
              	@module-license:
              		The MIT License (MIT)
              		@mit-license
              
              		Copyright (@c) 2017 Richeve Siodina Bebedor
              		@email: richeve.bebedor@gmail.com
              
              		Permission is hereby granted, free of charge, to any person obtaining a copy
              		of this software and associated documentation files (the "Software"), to deal
              		in the Software without restriction, including without limitation the rights
              		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              		copies of the Software, and to permit persons to whom the Software is
              		furnished to do so, subject to the following conditions:
              
              		The above copyright notice and this permission notice shall be included in all
              		copies or substantial portions of the Software.
              
              		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              		SOFTWARE.
              	@end-module-license
              
              	@module-configuration:
              		{
              			"package": "bse",
              			"path": "bse/bse.js",
              			"file": "bse.js",
              			"module": "bse",
              			"author": "Richeve S. Bebedor",
              			"eMail": "richeve.bebedor@gmail.com",
              			"repository": "https://github.com/volkovasystems/bse.git",
              			"test": "bse-test.js",
              			"global": true
              		}
              	@end-module-configuration
              
              	@module-documentation:
              		Base conversion class.
              	@end-module-documentation
              */



//: @client:
var Base = __webpack_require__(127);
//: @end-client

var bse = function bse() {
	return Base;
};

module.exports = bse;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*;
              	@submodule-license:
              		The MIT License (MIT)
              		@mit-license
              
              		Copyright (@c) 2017 Richeve Siodina Bebedor
              		@email: richeve.bebedor@gmail.com
              
              		Permission is hereby granted, free of charge, to any person obtaining a copy
              		of this software and associated documentation files (the "Software"), to deal
              		in the Software without restriction, including without limitation the rights
              		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              		copies of the Software, and to permit persons to whom the Software is
              		furnished to do so, subject to the following conditions:
              
              		The above copyright notice and this permission notice shall be included in all
              		copies or substantial portions of the Software.
              
              		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              		SOFTWARE.
              	@end-submodule-license
              
              	@submodule-configuration:
              		{
              			"package": "bse",
              			"path": "bse/base.module.js",
              			"file": "base.module.js",
              			"module": "bse",
              			"author": "Richeve S. Bebedor",
              			"eMail": "richeve.bebedor@gmail.com",
              			"repository": "https://github.com/volkovasystems/bse.git",
              			"test": "bse-test.js",
              			"global": false,
              			"internal": true,
              			"class": true
              		}
              	@end-submodule-configuration
              
              	@submodule-documentation:
              		Base class construct.
              
              		The purpose of this class is to facilitate the base conversion.
              		This should not contain ways of introspection.
              	@end-submodule-documentation
              
              	@include:
              		{
              			"falzy": "falzy"
              		}
              	@end-include
              */var _classCallCheck2 = __webpack_require__(37);var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);var _createClass2 = __webpack_require__(38);var _createClass3 = _interopRequireDefault(_createClass2);var _symbol = __webpack_require__(34);var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var falzy = __webpack_require__(57);

var EMPTY_STRING = "";

var ENCODE = "encode";
var DECODE = "decode";
var IDLE = "idle";

var ERROR = (0, _symbol2.default)("error");
var RESULT = (0, _symbol2.default)("result");
var MODE = (0, _symbol2.default)("mode");
var DATA = (0, _symbol2.default)("data");var

Base = function () {
	function Base(data, base) {(0, _classCallCheck3.default)(this, Base);
		/*;
                                                                       	@meta-configuration:
                                                                       		{
                                                                       			"data": "*",
                                                                       			"base": "number"
                                                                       		}
                                                                       	@end-meta-configuration
                                                                       */

		if (
		typeof base != "number" ||
		isNaN(base) ||
		!isFinite(base) ||
		base < 2)
		{
			throw new Error("invalid base, " + base);
		}

		this[DATA] = this.parse(data);
		this[RESULT] = EMPTY_STRING;
		this[MODE] = IDLE;
		this[ERROR] = null;
	}

	/*;
   	@method-documentation:
   		Parse the data to make it compatible for conversion.
   	@end-method-documentation
   		@note:
   		This should be overridden if possible.
   	@end-note
   */(0, _createClass3.default)(Base, [{ key: "parse", value: function parse(

		data) {
			/*;
         	@meta-configuration:
         		{
         			"data": "*"
         		}
         	@end-meta-configuration
         */

			if (falzy(data)) {
				data = EMPTY_STRING;
			}

			try {
				return "" + data;

			} catch (error) {
				this.setError(new Error("cannot parse data, " + error.stack));

				return data;
			}
		}

		/*;
    	@method-documentation:
    		Encode the data.
    	@end-method-documentation
    		@note:
    		This should be overridden.
    	@end-note
    */ }, { key: "encode", value: function encode(

		done) {
			/*;
         	@meta-configuration:
         		{
         			"done": "function"
         		}
         	@end-meta-configuration
         */

			this.setEncodeMode();

			try {
				if (typeof done == "function") {
					done.call(this, null, EMPTY_STRING);

					return this;

				} else {
					return EMPTY_STRING;
				}

			} finally {
				this.setResult(EMPTY_STRING);

				done = undefined;
			}
		}

		/*;
    	@method-documentation:
    		Decode the data.
    	@end-method-documentation
    		@note:
    		This should be overridden.
    	@end-note
    */ }, { key: "decode", value: function decode(

		done) {
			/*;
         	@meta-configuration:
         		{
         			"done": "function"
         		}
         	@end-meta-configuration
         */

			this.setDecodeMode();

			try {
				if (typeof done == "function") {
					done.call(this, null, EMPTY_STRING);

					return this;

				} else {
					return EMPTY_STRING;
				}

			} finally {
				this.setResult(EMPTY_STRING);

				done = undefined;
			}
		} }, { key: "clear", value: function clear()

		{
			this[RESULT] = EMPTY_STRING;
			this[ERROR] = null;
			this[MODE] = IDLE;
		} }, { key: "flush", value: function flush()

		{
			this.clear();
			this[DATA] = EMPTY_STRING;
		} }, { key: "setEncodeMode", value: function setEncodeMode()

		{
			this[MODE] = ENCODE;

			return this;
		} }, { key: "isEncodeMode", value: function isEncodeMode()

		{
			return this[MODE] === ENCODE;
		} }, { key: "setDecodeMode", value: function setDecodeMode()

		{
			this[MODE] = DECODE;

			return this;
		} }, { key: "isDecodeMode", value: function isDecodeMode()

		{
			return this[MODE] === DECODE;
		} }, { key: "setIdleMode", value: function setIdleMode()

		{
			this[MODE] = IDLE;

			return this;
		} }, { key: "isIdleMode", value: function isIdleMode()

		{
			return this[MODE] === IDLE;
		} }, { key: "getData", value: function getData()

		{
			return this[DATA];
		} }, { key: "setResult", value: function setResult(

		result) {
			/*;
           	@meta-configuration:
           		{
           			"result": "*"
           		}
           	@end-meta-configuration
           */

			this[RESULT] = result;

			return this;
		} }, { key: "getResult", value: function getResult()

		{
			return this[RESULT];
		} }, { key: "setError", value: function setError(

		error) {
			/*;
          	@meta-configuration:
          		{
          			"error": Error
          		}
          	@end-meta-configuration
          */

			if (error instanceof Error) {
				this[ERROR] = error;
			}

			return this;
		} }, { key: "hasError", value: function hasError()

		{
			return this[ERROR] instanceof Error;
		} }, { key: "getError", value: function getError()

		{
			return this[ERROR];
		} }]);return Base;}();


module.exports = Base;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// ehm.deploy.js